export const translations = {
  // --- IDIOMA ESPAÑOL ---
  es: {
    home: {
      // <<-- NUEVAS CLAVES PARA HOME -->>
      heroLine1: "Bienvenido a la comunidad de",
      heroWords: ["Consultores", "Talento", "Especialistas", "Profesionales"],
      heroLine3: "",
      exploreCommunity: "Explora la comunidad",
      searchPlaceholder:
        "Escribe el problema que quieres resolver y Repli encuentrará un Especialista adecuado.",
      dropzone: "Suelta tu PDF o JPG aquí para adjuntarlo",
      unsupportedFile:
        "Tipo de archivo no admitido. Por favor, sube archivos PDF, JPG o PNG.",
      cancelRequest: "Cancelación solicitada, pero no implementada.",
      errorConnect: "Lo siento, no pude conectarme. Inténtalo de nuevo.",
      thinking: "Pensando...",
      servicesTitle: "Nuestros servicios",
      servicesSubtitle:
        "Elije uno de nuestros para iniciar una búsqueda rápida.",
      serviceCV: "Creación de CV",
      serviceConsulting: "Consultoría empresarial",
      // Discover Section
      discoverTitle: "Descubre más",
      discoverBlogTitle: "Novedades y Artículos",
      discoverBlogDesc: "Explora las últimas tendencias en IA y desarrollo profesional en nuestro blog.",
      discoverBlogBtn: "Ir al Blog",
      discoverAboutTitle: "Conoce nuestra Visión",
      discoverAboutDesc: "Entiende cómo estamos transformando el futuro del trabajo independiente.",
      discoverAboutBtn: "Sobre Nosotros",

      // Fabrica tu Repliker Section
      factoryTitle: "¿Listo para tener tu propio Repliker?",
      factoryP1_1:
        "Transforma tu presencia digital y amplifica tu voz. Con un ",
      factoryP1_2:
        ", puedes escalar tu conocimiento y estar disponible para tu audiencia 24/7.",
      factoryP2_1: "¿Estás listo para crear tu propia versión digital?",
      factoryP2_2: "¡Da el primer paso para amplificar tu impacto en el mundo!",
      factoryP3_1: "Expande tu negocio o marca personal:",
      factoryP3_2:
        "Un repliker puede servir como tu asistente virtual, un consultor instantáneo o un creador de contenido con tu sello personal.",
      factoryP4:
        "Agenda una reunión con nosotros para descubrir cómo podemos crear una réplica digital de ti.",
      factoryButton: "¡Fabrica tu Repliker!",
    },
    header: {
      home: "Inicio",
      hire: "Comunidad RepliKers",
      blog: "Blog",
      news: "Noticias",
      about: "Sobre Nosotros",
      build: "Fabrica tu RepliKers",
      community: "Comunidad",
      social: "Social",
      profile: "Perfil",
      logout: "Cerrar Sesión",
      login: "Iniciar Sesión",
      messaging: "Mi mensajería",
      // Textos para accesibilidad (alt y aria-labels)
      openMenu: "Abrir menú",
      myProfileAlt: "Mi Perfil",
    },
    footer: {
      // <<-- NUEVAS CLAVES PARA FOOTER -->>
      slogan: "Impulsando el futuro.",
      socialMedia: "Redes sociales",
      contactUs: "Contáctanos",
      quickLinks: "Atajos útiles",
      replikersList: "Lista de replikers",
      blog: "Blog",
      social: "Social",
      aboutUs: "Sobre Nosotros",
      copyText: "Todos los derechos reservados.",
      company: "Conauti LATAM.",
      privacyPolicy: "Política de Privacidad",
      termsOfService: "Términos de Servicio",
    },
    replikers: {
      mainTitle: "Nuestros RepliKers",
      subtitle: "Encuentra tu repliker ideal.",
      tryNow: "Conversa ahora",
      areaHR: "Recursos Humanos y Gestión del Talento",
      areaLegal: "Asesoría Legal y Corporativa",
      areaCareer: "Desarrollo Profesional y Carreras",
      areaProjectMgmt: "Gestión de Proyectos",
      areaEngineering: "Ingeniería",
      areaFinance: "Finanzas(Riesgo y cobranzas)",
      areaSoftware: "Desarrollo de Software e IA",
      areaAIFounder: "AI Product Founder",
    },
    filtersReplikers: {
      // <<-- NUEVO CAMPO PARA FILTROS -->>
      areaLabel: "Área / Categoría",
      applyButton: "Aplicar Filtros",
      all: "Todos",
      generalist: "Generalista",
    },
    about: {
      //CLAVES PARA ABOUT PAGE
      // Títulos principales
      whoWeAre: "Quiénes Somos",
      forWho: "¿Para Quién es RepliKers?",
      challengeProposal: "¿Por Qué RepliKers? El Desafío y Nuestra Propuesta",
      whatIsRepliker:
        "¿Qué es un RepliKers? Tu Réplica Digital de Alto Rendimiento",
      impact: "El Impacto de un RepliKers: Escala Tus Servicios, No Tus Horas",
      visionMission: "Nuestra Visión, Misión y Tu Próximo Paso",

      // Contenido - Quiénes Somos
      whoWeAreP1_1:
        "En RepliKers, estamos construyendo el Sistema Operativo IA First que todo profesional que busca independizarse necesita para alcanzar un crecimiento exponencial. Fundada en Agosto de 2024, nuestra misión es transformar tu conocimiento en una réplica digital inteligente capaz de automatizar ventas, marketing y atención al cliente. Al integrar herramientas como Google (Gmail), permitimos que tu réplica gestione de manera eficiente tu comunicación profesional con respuestas rápidas y personalizadas, impulsando tu impacto como profesional independiente sin comprometer la privacidad de tus datos.",

      // Contenido - Para Quién
      forWhoP1:
        "Nuestro sistema está diseñado para el experto de alto valor que anhela crecer y escalar su impacto sin sacrificar su vida personal.",
      proTitle: "El Profesional Independiente:",
      proP1:
        "Si ya posees una experticia probada y deseas multiplicar tus ingresos y tu alcance sin comprometer tu tiempo personal, Replikers es tu aliado.",
      founderTitle: "El Futuro Fundador de una Consultora Boutique:",
      founderP1:
        "Aquellos que buscan transformar su conocimiento individual en una empresa de servicios boutique, altamente escalable y automatizada, lista para dominar en la era de la Inteligencia Artificial.",
      challengeP1:
        "Entendemos el desafío: 'No puedo crecer más sin sacrificar mi vida personal.' Las tareas operativas (ventas, marketing, administración) consumen el tiempo que deberías dedicar a entregar valor real a tus clientes.",

      // Contenido - Desafío y Propuesta
      problemTitle: "El Problema Central: Un Crecimiento Lineal y Agotador",
      problemL1:
        "El crecimiento profesional suele ser lineal, lento y doloroso.",
      problemL2:
        "Estás invirtiendo tiempo valioso en tareas repetitivas de operación (comerciales, marketing y administrativas), lo que te impide escalar tu negocio más allá de tus horas disponibles y compromete la consistencia de tu servicio.",
      opportunityTitle: "Nuestra Oportunidad: De Lineal a Exponencial",
      opportunityP1_1:
        "Replikers convierte tu experiencia y tu tiempo en un Activo Digital 24/7 que trabaja ininterrumpidamente para ti. Te movemos de un modelo de negocio lineal a uno exponencial, escalando tu metodología y no simplemente tus horas de trabajo.",

      // Contenido - Qué es un Repliker
      whatIsP1:
        "Un Repliker es tu Sistema Operativo IA First: una extensión inteligente, empoderada por tu conocimiento y entrenada específicamente en tu metodología para impulsar tu crecimiento independiente.",
      whatIsP2:
        "Esencialmente, es un un asistente de ventas y servicio hiper-especializado que lleva tu nombre y apellido, entrenado únicamente en tus procesos y filosofía.",
      componentsTitle: "Sus Componentes Clave:",
      componentL1Title: "Hyper-Especialización (ADN Único):",
      componentL1Desc:
        "Fabricado con Fine Tuning y Retrieval-Augmented Generation (RAG) sobre tu data única (playbooks, insights, plantillas), tu Repliker adopta tu personalidad. No es un agente IA genérico; es el único capaz de entregar tu servicio exactamente como tú lo harías.",
      componentL2Title: "Funcionalidad Autónoma:",
      componentL2Desc:
        "Entrenado para Observar, Razonar y Actuar, tu Repliker se conecta a tus herramientas clave (Google Calendar, email, WhatsApp, RRSS) para ejecutar flujos de trabajo completos. Esto significa que puede realizar tareas sin supervisión, desde buscar leads hasta gestionar tu bandeja de entrada unificada.",
      componentL3Title: "Estrategia de Monetización Inteligente:",
      componentL3Desc:
        "Tu Repliker puede ofrecer asesorías, ejecutar tareas o agendar consultas personalizadas, cobrando automáticamente antes de entregar el servicio. Esto genera ingresos pasivos a través de múltiples fuentes: consultorías, tareas específicas, publicidad y tráfico de comunidad.",

      // Contenido - Impacto
      impactP1_1:
        "Tu Repliker es el motor que orquesta y automatiza el crecimiento de tu negocio profesional independiente, permitiéndote ",
      impactP1_2: "escalar tus servicios, no tus horas.",
      impactP1_3:
        "Estamos especializados en potenciar a consultores independientes, freelancers y en la creación de consultoras boutique.",
      benefitsTitle: "Beneficios Clave:",
      benefitL1Title: "Venta y Marketing 24/7:",
      benefitL1Desc:
        "Tu Repliker atiende y cualifica cada lead de tus redes sociales, WhatsApp o email. Es tu asesor de ventas incansable, creando y gestionando tu embudo de ventas de forma automática.",
      benefitL2Title: "Escalabilidad Garantizada:",
      benefitL2Desc:
        "Amplifica tu alcance a nivel mundial, disponible las 24 horas, los 7 días de la semana, en cualquier idioma. Mantiene una calidad de resultado consistente sin consumir tus horas personales.",
      benefitL3Title: "Blindaje ante la IA:",
      benefitL3Desc:
        "Te proporciona una ventaja competitiva única. En lugar de competir contra agentes IA genéricos, utilizas tu Repliker para multiplicar tu eficiencia, velocidad y capacidad de análisis de datos.",
      benefitL4Title: "Imagen Profesional Mejorada:",
      benefitL4Desc:
        "Proyecta una representación consistente, precisa y de vanguardia de tu expertise, elevando tu marca personal como un líder que domina la Inteligencia Artificial.",
      benefitL5Title: "Superpoderes:",
      benefitL5Desc:
        "Adquiere los superpoderes de un activo digital: Disponibilidad 24/7, Escalabilidad ilimitada, Velocidad de Ejecución sin precedentes y Precios Competitivos.",
      benefitL6Title: "Inbox Unificado e Inteligente:",
      benefitL6Desc:
        "Recibe todas las comunicaciones de tus leads unificadas y filtradas por tu Repliker. Solo verás lo importante, y tu Repliker siempre responderá a lo esencial y urgente.",
      benefitL7Title: "Búsqueda de Trabajo Activa:",
      benefitL7Desc:
        "Si lo deseas, tu Repliker puede buscar de manera proactiva oportunidades de trabajo tradicionales, optimizando tus posibilidades.",

      // Contenido - Visión y Misión
      visionTitle: "Visión:",
      visionP1:
        "Ser el Sistema Operativo IA FIRST líder global, escalando el conocimiento profesional y transformándolo en Empresas de Servicios Boutique o Servicios Profesionales Independientes totalmente automatizadas, eliminando el dolor de la escala a través de la IA.",
      missionTitle: "Misión:",
      missionP1:
        "Crear un sistema operativo impulsado por IA FIRST que ejecute y orqueste todas las tareas comerciales, marketing y administrativas que un profesional independiente necesita para crecer y escalar.",
      competitiveTitle: "Nuestra Ventaja Competitiva:",
      competitiveP1:
        "La automatización completa de todas las tareas (comerciales, marketing, administrativas) que un profesional independiente necesita para crecer, centradas en su conocimiento y expertise únicos.",
      readyForFutureTitle: "¿Listo para el Futuro?",
      readyForFutureP1_1:
        "Si estás listo para dejar de vender tus horas y empezar a vender tu activo digital, agenda una reunión ahora para comenzar a fabricar tu Repliker:",
      scheduleLink: "https://bit.ly/CitaRepliker",
    },
    chat: {
      replikerNotFound: "Repliker no encontrado.",
      emptyChatPrompt: "¿En qué te puedo ayudar hoy?",
      loginPrompt: "Por favor, inicia sesión para chatear.",

      // Indicadores de estado de la IA
      thinking: "Pensando...",
      thinkingMoment: "Un momento...",
      thinkingRefining: "Refinando...",

      // Manejo de errores y acciones
      errorDefault: "Lo siento, ocurrió un error.",
      newChat: "Nuevo chat",
      noActiveConversation:
        "No hay conversación activa para enviar el mensaje.",
      requestCanceled: "Petición cancelada por el usuario.",

      // Drag & Drop
      dropzone: "Suelta tu PDF o JPG aquí para adjuntarlo",
      unsupportedFile:
        "Tipo de archivo no admitido. Por favor, sube archivos PDF, JPG o PNG.",

      // Sidebar
      newConversationButton: "Nueva Conversación", // Asumiendo que existe un botón en ProfileSidebar
    },
    chatComponent: {
      // ProfleSidebar
      share: "Compartir",
      historyTitle: "Historial de Chats",
      newConversationButton: "+ Nueva Conversación",
      updateError: "Error al actualizar el nombre del chat.",
      userLabel: "Tú", // Si se necesita
      botLabel: "Bot", // Si se necesita

      // ChatMessage (Archivos)
      fileDefaultName: "Archivo",
      fileAttachedLabel: "Archivo adjunto:",
      imageAlt: "Adjunto",
      viewLink: "Ver enlace",

      // AudioRecordModal
      modalTitle: "Grabar Audio",
      closeButtonLabel: "Cerrar",
      statusIdle: "Presiona para grabar",
      statusRecording: "Grabando...",
      statusRecorded: "Audio grabado",
      buttonRecord: "Grabar",
      buttonStop: "Detener",
      buttonRecordAgain: "Grabar de nuevo",
      buttonCancel: "Cancelar",
      buttonSend: "Enviar",
      errorMicrophoneAccess:
        "No se pudo acceder al micrófono. Verifica los permisos.",
      errorRecordingStop: "Ocurrió un error al detener la grabación.",

      // ConversationBar (Input/Placeholder/Botones)
      filePreviewAlt: "Vista previa del archivo",
      attachFileTitle: "Adjuntar archivo",
      attachFileLabel: "Adjuntar archivo",
      recordAudioTitle: "Grabar audio",
      recordAudioLabel: "Grabar audio",
      placeholderThinking: "Esperando respuesta...",
      placeholderDefault: "Pregunta lo que quieras",
      stopButtonAlt: "Detener", // Para el botón de detener la carga
    },
    blog: {
      // Títulos y mensajes de estado
      heroTitle: "Echa un vistazo a nuestro blog",
      loading: "Cargando blogs...",

      // Botones y acciones
      readArticle: "Leer artículo",

      // Mensajes de error/verificación (Modales)
      verificationError: "Código de verificación incorrecto.",
      verificationErrorGeneral: "Error al verificar el código.",

      // Accesibilidad
      heroAlt: "Fondo de héroe del blog",
    },
    editBlog: {
      modalTitle: "Editar blog",
      titleLabel: "Título:",
      dateLabel: "Fecha:",
      imageUrlLabel: "URL de la Imagen:",
      contentLabel: "Contenido (Markdown):",
      updateButton: "Actualizar Blog",

      // Mensajes de estado
      updating: "Actualizando blog...",
      success: "¡Blog actualizado con éxito!",
      errorDefault: "No se pudo actualizar el blog.",
      errorPrefix: "Error:",
    },
    blogPost: {
      loading: "Cargando artículo...",

      // Mensajes de error
      notFoundTitle: "Artículo no encontrado",

      // Enlaces
      backToBlog: "Volver al blog",
      backToBlogList: "Volver a la lista de blogs",

      // Etiquetas
      publicationDate: "Fecha de publicación:",
      relatedBlogsTitle: "Artículos relacionados", // Asumo que querrás este título en el sidebar
    },
    notifications: {
      like: "A {name} le gustó tu publicación",
      follow: "{name} te empezó a seguir",
      comment: "{name} comentó en tu publicación",
      reply: "{name} respondió a tu comentario",
      mention: "{name} te mencionó en una publicación",
      default: "{name} interactuó contigo",
    },
    social: {
      // General & Sidebar
      headerTitle: "Social",
      navHome: "Inicio",
      navExplore: "Explorar",
      navNotifications: "Notificaciones",
      navFollowing: "Siguiendo",
      navMessages: "Mensajes",
      navProfile: "Perfil",
      navPostBtn: "Publicar",
      whatsHappening: "¿Qué está pasando?",

      // ChatPage
      loading: "Cargando...",
      loadingChat: "Cargando chat...",
      noConversationsTitle: "No tienes aún mensajes",
      noConversationsText: "Envía un mensaje para empezar una conversación.",
      clearChat: "Limpiar chat",
      deleteConversation: "Eliminar conversación",
      selectMessageTitle: "Selecciona un mensaje",
      selectMessageText:
        "Elige entre tus conversaciones existentes, empieza una nueva o sigue nadando.",
      newMessageBtn: "Nuevo mensaje",
      newMessageModalTitle: "Nuevo mensaje",
      nextBtn: "Siguiente",
      noPeopleFound: "No se encontraron personas",

      // ExplorePage
      exploreTitle: "Explorar",
      newContentTitle: "¡Nuevo contenido muy pronto!",
      newContentText:
        "Estamos trabajando en nuevas formas de descubrir contenido.",

      // PostFeed & PostDetail
      postHeader: "Publicación",
      loadMore: "Cargar más",
      feedEnd: "No hay más publicaciones",
      feedEmpty: "Aún no hay publicaciones",

      // CreatePost
      loginToShare: "Inicia sesión para compartir tus pensamientos...",
      createPostPlaceholder: "¡¿Qué está pasando?!",
      postingBtn: "Publicando...",
      postBtn: "Publicar",

      // CommentSection
      loadingComments: "Cargando comentarios...",
      editBtn: "Editar",
      deleteBtn: "Eliminar",
      saveBtn: "Guardar",
      cancelBtn: "Cancelar",
      addCommentPlaceholder: "Añade un comentario...",
      replyingTo: "Respondiendo a",

      // NotificationsPage
      notificationsTitle: "Notificaciones",
      loginNotifTitle: "Inicia sesión para ver notificaciones",
      loginNotifText:
        "Únete a la conversación para ver quién interactúa contigo.",
      loginBtn: "Iniciar sesión",
      noNotificationsTitle: "No hay notificaciones aún",
      noNotificationsText:
        "Cuando alguien le de me gusta a tu publicación o te siga, lo verás aquí.",

      // PostItem (Nuevos agregados planos)
      postShareMsgPrefix: "Quiero hablar más sobre:",
      postShareMsgImg: "esta imagen/video",
      postShareMsgPost: "este post",
      postSharedFrom: "Post compartido de",
      postFollow: "Seguir",
      postFollowing: "Siguiendo",
      postEdit: "Editar",
      postDelete: "Eliminar",
      postDeleteConfirm:
        "¿Estás seguro de que deseas eliminar esta publicación?",
      postShareVia: "Compartir vía",
      postCopyLink: "Copiar enlace",
      postSendTo: "Hablar con el repliker",
      postLinkCopied: "¡Enlace copiado al portapapeles!",
      postEditError: "Error al editar publicación",
      postDeleteError: "Error al eliminar publicación",
      postReadMore: "Leer más",
      postShowLess: "Mostrar menos",
      postSave: "Guardar",
      postCancel: "Cancelar",
      postCommentedLabel: "Comentó",
      postTooltipMore: "Más opciones",
      postTooltipReply: "Responder",
      postTooltipShare: "Compartir",

      // Repli Post + Blog
      repliGenerateBlog: "¿Quieres que también te genere un blog SEO para tu web?",
      repliGenerateBlogYes: "¡Sí, generar blog!",
      repliGenerateBlogNo: "Solo post",
      repliPublishing: "Publicando...",
      repliPostPublished: "¡Post publicado!",
      repliBlogPublished: "¡Blog publicado!",
      repliBothPublished: "¡Post y blog publicados!",
      repliPublishError: "Error al publicar",
      repliEditPost: "Editar post",
      repliEditBlog: "Editar blog",
      repliPublish: "Publicar",
      repliBlogTitle: "Título del blog",
      repliBlogContent: "Contenido del blog",
      repliBlogImageUrl: "URL de imagen",
      postTooltipLike: "Me gusta",
      postTooltipViews: "Vistas",
      postTooltipSendRepliker: "Hablar con el repliker",

      // SocialProfilePage
      profileCheckOut: "¡Echa un vistazo al perfil de {name} en Replikers!",
      profileLinkCopied: "¡Enlace del perfil copiado al portapapeles!",
      profileUserNotFound: "Usuario no encontrado",
      profilePostsCount: "publicaciones",
      profileAddCover: "Añadir foto de portada",
      profileEditBtn: "Editar Perfil",
      profileShareTooltip: "Compartir Perfil",
      profileBioPlaceholder: "Añadir descripción", // Clickable placeholder
      profileStatsFollowing: "Siguiendo",
      profileStatsFollowers: "Seguidores",
      profileTabPosts: "Publicaciones",
      profileTabReplies: "Respuestas",
      profileRepliedTo: "Respondió a",
      profileNoPosts: "Aún no hay publicaciones",
      profileNoReplies: "Aún no hay respuestas",
      profileComingSoon: "Próximamente",

      // Edit Profile Modal
      profileModalTitle: "Editar Perfil",
      profileLabelName: "Nombre",
      profileLabelUsername: "Nombre de usuario",
      profileLabelBio: "Biografía",
      profileInputBioPlaceholder: "Añade una biografía a tu perfil",
      profileSaving: "Guardando...",
      profileSave: "Guardar",
      profileUpdateError: "Error al actualizar perfil",

      // UserSearch
      searchPlaceholder: "Buscar",
      searchNoResults: "No se encontraron resultados",
      searchOwnersTitle: "Nuestros Replikers",
      searchOwnersSubtitle: "Descubre lo nuevo de nuestros replikers",
    },
    profile: {
      // Tabs
      myAccount: "Mi cuenta",
      myPurchases: "Mis compras",
      myRepliker: "MI REPLIKER",
      myMessaging: "Mi mensajería",
      addContent: "AÑADE CONTENIDO",
      settings: "Configuraciones",
      uploadedFiles: "Archivos subidos",
      returnToChat: "Regresar chat",
      // Mi Cuenta
      myProfileTitle: "Mi Perfil",
      changePhoto: "Cambiar foto",
      loading: "Cargando...",
      logout: "Cerrar sesión",
      personalInfo: "Información personal",
      edit: "Editar",
      country: "País",
      selectCountry: "Selecciona un país",
      phone: "Número telefónico",
      update: "Actualizar",
      cancel: "Cancelar",
      notAvailable: "No disponible",
      saved: "¡Perfil actualizado!",
      errorSave: "¡Error al actualizar!",
      name: "Nombre",
      displayNameLabel: "Nombre a mostrar:",
      displayNamePlaceholder: "Tu nombre Completo",
      professionLabel: "ROL / POSICIÓN / PROFESIÓN:",
      professionPlaceholder: "Ej: Ing. de Software (Obligatorio para tu Repliker)",
      areaLabel: "Área / Categoría:",
      selectCategory: "Selecciona una categoría (Obligatorio para tu Repliker)",
      // Mis Compras
      historyPurchases: "Historial de compras",
      historyPurchasesDesc:
        "Si hiciste compras o adquiriste servicios y no se ven aquí, no te preocupes estamos trabajando en ello.",
      // Dashboard
      dashboardTitle: "Dashboard de Mi Repliker",
      chatHistory: "Historial de Conversaciones",
      recentConvs: "Conversaciones Recientes:",
      loadingHistory: "Cargando historial de conversaciones...",
      noHistory: "No hay conversaciones recientes de tu Repliker.",
      session: "Sesión",
      with: "con",
      userLabel: "Usuario",
      replikerLabel: "Repliker",
      noMessages: "No hay mensajes en esta sesión.",
      seeFullHistory: "Ver Historial Completo",
      // Subtabs
      aiAnalysis: "Análisis IA",
      summary: "Resumen",
      // Analysis Section
      analysisBadge: "Análisis de Insights",
      analysisDesc: "Pregúntale a tu Repliker sobre el rendimiento de tus publicaciones, interacciones, pidele asistencia para obtener insights, seguimientos u otro tipo de acciones.",
      resetAnalysis: "Reiniciar Análisis",
      analysisReady: "Tu asistente de datos está listo. ¿Qué quieres analizar hoy?",
      analysisPlaceholder: "Ej: ¿Qué tipo de contenido generó más comentarios este mes?",
      clearChat: "Limpiar Conversación",
      activeAgent: "Agente Activo",
      days7: "7 Días",
      days30: "30 Días",
      months3: "3 Meses",
      viewsTrend: "Tendencia de Vistas",
      interactionPeaks: "Picos de Interacción",
      conversionFunnel: "Embudo de Conversión",
      noText: "Sin texto",
      searchById: "Buscar por ID...",
      sessionId: "ID Sesión",
      fullTranscript: "Transcripción Completa",
      downloadTxt: "Descargar TXT",
      noMessagesInConv: "Sin mensajes en esta conversación.",
      highRelation: "Relación Alta",
      file: "Archivo",
      view: "Ver",
      noFilesUploaded: "No hay archivos subidos aún.",
      addPostPlaceholder: "Describe el contenido que quieres crear o adjunta un archivo...",
      // Mi mensajeria
      menssagingTitle: "Mi mensajería",
      menssagingSubtitle: "Centraliza tus notificaciones de Gmail y LinkedIn en un solo lugar.",
      providerGmail: "Google Gmail",
      providerLinkedIn: "LinkedIn",
      connectGmail: "Conectar Gmail",
      connectLinkedIn: "Conectar LinkedIn",
      unifiedInbox: "Bandeja de Entrada Unificada",
      loadingNotifs: "Cargando notificaciones...",
      noNotifs: "No tienes notificaciones pendientes.",
      notifFromLabel: "De:",
      notifCloseBtn: "Cerrar",
      notifDisclaimer: "Nota: Esta es una vista previa del mensaje unificado.",
      errorLoadNotifs: "Error al cargar notificaciones. Asegúrate de conectar tus cuentas.",
      errorConnectGoogle: "Error al iniciar la conexión con Google.",
      errorConnectLinkedIn: "Error al iniciar la conexión con LinkedIn.",
      // Añade contenido
      addPostTitle: "Añade contenido con Repli",
      addPostText:
        "Describe el contenido que quieres subir o adjunta un archivo para que Repli lo procese.",
      addPostEmptyChatMsg: "¿Qué contenido te gustaría añadir hoy?",
      creativeStudio: "Estudio Creativo",
      templateSocial: "Post para Redes",
      templateBlog: "Artículo de Blog",
      templateVideo: "Guion de Video",
      templateNewsletter: "Newsletter",
      // Settings
      theme: "Tema",
      dark: "Oscuro",
      light: "Claro",
      language: "Idioma",
      spanish: "Español",
      english: "Inglés",
      portuguese: "Portugués",
      comingSoon: "Muy pronto nuevos idiomas/temas.",
      // Insights
      insightsTitle: "Insights de Rendimiento",
      insightsSummary: "Resumen de Rendimiento",
      totalPosts: "Total de Publicaciones",
      totalViews: "Vistas Totales",
      totalInteractions: "Interacciones Totales",
      convsStarted: "Conversaciones Iniciadas",
      postDetails: "Detalles por Publicación",
      interactions: "Interacciones",
      views: "Vistas",
      comments: "Comentarios",
      shares: "Compartidos",
      avgDwellTime: "Tiempo Promedio",
      dwellTime: "Permanencia",
      avgConversationTime: "Tiempo Conv. Promedio",
      infoAvgConversationTime: "Duración promedio de las sesiones de chat de los usuarios con tu Repliker.",
      ctrActions: "CTR / Acciones",
      showMore: "Ver más",
      showLess: "Ver menos",
      // Tooltips for Insights
      infoViewsTrend: "Muestra la evolución del número de visualizaciones de tus contenidos a lo largo del periodo seleccionado.",
      infoInteractionPeaks: "Identifica los momentos con mayor número de interacciones (likes, comentarios, compartidos) en tus publicaciones.",
      infoConversionFunnel: "Visualiza el viaje del usuario desde que ve tu contenido hasta que inicia una conversación con tu Repliker.",
      infoTotalViews: "Suma total de veces que tus publicaciones han sido visualizadas por usuarios.",
      infoTotalPosts: "Cantidad total de contenidos que has publicado en la plataforma.",
      infoTotalInteractions: "Suma total de likes, comentarios y veces que se ha compartido tu contenido.",
      infoConvsStarted: "Número de veces que un usuario ha iniciado un chat directamente con tu Repliker desde tus contenidos.",
      infoAvgDwellTime: "Tiempo promedio que los usuarios pasan viendo tus publicaciones.",
      // CRM
      crmTab: "CRM",
      crmTitle: "Gestión de Contactos (Leads)",
      crmDesc: "Aquí aparecen los datos capturados por tu Repliker cuando un usuario proporciona su información.",
      colName: "Nombre",
      colEmail: "Email",
      colPhone: "Teléfono",
      colRole: "Rol",
      colCompany: "Empresa",
      colService: "Servicio de Interés",
      colDetails: "Detalles del Problema",
      colStatus: "Estado",
      colFollowups: "Seguimientos",
      actionFollowup: "Seguimiento",
      // Nuevas columnas CRM
      colContactType: "Tipo Contacto",
      colWebsite: "Sitio Web",
      colAddress: "Dirección",
      colCity: "Ciudad",
      colCountry: "País",
      colLinkedin: "LinkedIn",
      colEmailPref: "Pref. Email",
      colOrigin: "Origen",
      colLastContact: "Último Contacto",
      colDate: "Fecha Captura",
      colNotes: "Notas Internas",
      noLeads: "Aún no hay leads capturados.",
      loadingLeads: "Cargando contactos...",
      becomeOwnerSuccessMsgShort: "Cuenta Owner activada",
      becomeOwnerRevoked: "Cuenta Owner revocado. Contacta a soporte: +1 (415) 604-6499 | hola@replikers.com",
      createOrEditRepliker: "Crea o Edita tu Repliker",
      missingFieldsError: "Faltan campos por completar.",

      // Guest Restricted
      guestRestrictedTitle: "Acceso Limitado",
      guestRestrictedDesc: "Como invitado, no puedes personalizar tu perfil ni acceder a funciones avanzadas. Regístrate para desbloquear todas las herramientas.",
    },
    verificationModal: {
      modalTitle: "Verificación Requerida",
      descriptionP1:
        "Para editar este artículo, por favor introduce el código de verificación:",
      placeholder: "Código de verificación",
      buttonVerify: "Verificar",
    },
    repli: {
      placeholder: "Escribe tu mensaje...",
      buttonSend: "Enviar",
      errorDefault: "Lo siento, no pude procesar tu solicitud.",
      errorContact: "Error al contactar al agente Repli:",
    },
    login: {
      welcomeTitle: "Bienvenido a la comunidad de los Replikers",
      loginHeader: "Inicia sesión con",
      loginButtonGoogle: "Iniciar sesión con Google",
      loginButtonEmail: "Iniciar sesión con Correo",
      guestButton: "Ingresar como invitado",
      braveWarningBold: "¿Usas Brave?",
      braveWarningText:
        "Si el inicio con Google falla, desactiva temporalmente los Escudos (icono de león) para este sitio.",
      privacyMessage:
        "Usamos tu cuenta de Google únicamente para autenticarte. No accedemos a informacion privada.",
      poweredBy: "Powered by Conauti",
      guestError: "No se pudo ingresar como invitado. Inténtalo de nuevo.",
      googleLogoAlt: "Google Logo",
      emailLogoAlt: "Email Logo",
      userLogoAlt: "User Logo",
      registerSuccess: "Registro exitoso",

      // LoginForm
      loginTitle: "Inicia sesión en",
      emailPlaceholder: "Correo Electrónico",
      passwordPlaceholder: "Contraseña",
      loginButton: "Iniciar Sesión",
      loadingButton: "Iniciando sesión...",
      errorSession:
        "No se pudo iniciar sesión en el servidor. Inténtalo de nuevo.",
      errorVerificationNeeded:
        "Tu correo electrónico no ha sido verificado. Por favor, revisa tu bandeja de entrada.",
      errorLoginFailed: "Ocurrió un error al iniciar sesión.",
      errorInvalidCredentials:
        "El correo electrónico o la contraseña son incorrectos.",
      errorInvalidEmailFormat: "El formato del correo electrónico es inválido.",
      resendButton: "Reenviar correo de verificación",
      resendSuccess:
        "Se ha reenviado el correo de verificación. Por favor, revisa tu bandeja de entrada.",
      resendError:
        "No se pudo reenviar el correo de verificación. Inténtalo de nuevo más tarde.",
      toggleRegister: "¿No tienes una cuenta? Regístrate",

      // RegisterForm
      registerTitle: "Regístrate en",
      confirmPasswordPlaceholder: "Confirmar Contraseña",
      registerButton: "Registrarse",
      errorPasswordMismatch: "Las contraseñas no coinciden.",
      errorPasswordLength: "La contraseña debe tener al menos 6 caracteres.",
      errorRegisterFailed: "Ocurrió un error durante el registro.",
      errorEmailInUse: "El correo electrónico ya está en uso.",
      errorInvalidEmail: "El correo electrónico no es válido.",
      errorWeakPassword: "La contraseña es demasiado débil.",
      registerSuccessAlert:
        "¡Registro exitoso! Se ha enviado un correo de verificación a tu dirección de email. Por favor, verifica tu correo antes de iniciar sesión.",
      toggleLogin: "¿Ya tienes una cuenta? Inicia sesión",
    },
    privacyPolicy: {
      backBtn: "← Volver al inicio",
      mainTitle: "Política de Privacidad",
      lastUpdate: "Última actualización: 05 de enero de 2026",

      // Sección 1
      sec1Title: "1. Introducción",
      sec1Text:
        "En RepliKers, la privacidad de nuestros usuarios es nuestra prioridad. Esta política detalla cómo recopilamos, usamos y protegemos su información cuando utiliza nuestra plataforma y, específicamente, nuestra integración con los servicios de Google.",

      // Sección 2
      sec2Title: "2. Datos de Google que Recopilamos",
      sec2Sub1: "2.1. Autenticación Google OAuth2",
      sec2Text1: "Cuando inicia sesión con Google, accedemos a:",
      sec2List1Item1:
        "Email: Su dirección de correo electrónico para identificar su cuenta",
      sec2List1Item2:
        "Nombre: Su nombre completo para personalizar su experiencia",
      sec2List1Item3:
        "Foto de perfil: URL de su foto para mostrar en su perfil",
      sec2List1Item4:
        "ID de Google: Identificador único para vincular su cuenta",

      sec2Sub2: "2.2. Integración Gmail API",
      sec2Text2: "Cuando conecta su cuenta de Gmail, accedemos a:",
      sec2List2Item1:
        "Correos no leídos: Metadatos (asunto, remitente, fecha) de los últimos 10 correos no leídos",
      sec2List2Item2:
        "Fragmento de contenido: Un resumen breve (snippet) de cada correo para vista previa",
      sec2List2Item3:
        "Identificadores: ID único de cada mensaje para rastreamiento",
      sec2List2Item4:
        "Tokens de acceso: access_token y refresh_token para mantener la conexión activa",
      sec2Important:
        "Importante: NO accedemos al contenido completo de sus correos electrónicos, solo metadatos para notificaciones.",

      // Sección 3
      sec3Title: "3. Cómo Utilizamos los Datos de Google",
      sec3Sub1: "3.1. Datos de Autenticación",
      sec3Text1: "Utilizamos sus datos de autenticación para:",
      sec3List1Item1: "Crear y gestionar su cuenta de usuario en RepliKers",
      sec3List1Item2:
        "Iniciar sesión de manera segura sin necesidad de contraseña",
      sec3List1Item3:
        "Personalizar su experiencia con su nombre y foto de perfil",
      sec3List1Item4: "Identificarlo de manera única en nuestro sistema",

      sec3Sub2: "3.2. Datos de Gmail",
      sec3Text2: "Utilizamos los datos de Gmail exclusivamente para:",
      sec3List2Item1:
        "Mostrar notificaciones: Visualizar correos no leídos en su panel de mensajería",
      sec3List2Item2:
        "Unificar comunicaciones: Centralizar sus alertas profesionales en un solo lugar",
      sec3List2Item3:
        "Actualizar en tiempo real: Reflejar el estado actual de su bandeja de entrada",

      sec3ComplianceTitle:
        "Cumplimiento con la Política de Uso Limitado de Google:",
      sec3ComplianceItem1: "NO utilizamos sus datos de Gmail para publicidad",
      sec3ComplianceItem2:
        "NO vendemos, alquilamos ni compartimos sus datos con anunciantes",
      sec3ComplianceItem3:
        "NO utilizamos sus datos para entrenar modelos de IA externos",
      sec3ComplianceItem4:
        "NO almacenamos el contenido completo de sus correos electrónicos",
      sec3GooglePolicyLink:
        "Política de datos del usuario de los servicios de la API de Google",
      sec3GooglePolicyText:
        "El uso de la información recibida de las API de Google se adherirá estrictamente a la Política de datos del usuario de los servicios de la API de Google, incluidos los requisitos de Uso Limitado.",

      // Sección 4
      sec4Title: "4. Con Quién Compartimos los Datos de Google",
      sec4Sub1: "4.1. NO Compartimos sus Datos con Terceros para Publicidad",
      sec4Text1:
        "RepliKers NO vende, alquila, ni transfiere sus datos de Google a terceros para propósitos de marketing o publicidad.",

      sec4Sub2: "4.2. Proveedores de Servicios Esenciales",
      sec4Text2:
        "Podemos compartir sus datos únicamente con los siguientes proveedores de servicios esenciales que nos ayudan a operar nuestra plataforma:",
      sec4List1Item1:
        "Google Cloud Platform: Para almacenamiento seguro de tokens de acceso (servidor)",
      sec4List1Item2:
        "Google OAuth2: Para autenticación segura (solo intercambio de tokens)",
      sec4Note1:
        "Estos proveedores tienen prohibido utilizar sus datos para cualquier propósito diferente a proporcionar servicios a RepliKers.",

      sec4Sub3: "4.3. Personal Autorizado",
      sec4Text3:
        "Solo el personal autorizado de RepliKers puede acceder a sus datos para:",
      sec4List2Item1:
        "Proporcionar soporte técnico cuando usted lo solicite explícitamente",
      sec4List2Item2: "Realizar mantenimiento y debug del sistema",
      sec4List2Item3:
        "Investigar actividades sospechosas o incidentes de seguridad",
      sec4Note2:
        "Todo acceso por parte del personal está monitoreado y sujeto a acuerdos de confidencialidade estrictos.",

      sec4Sub4: "4.4. Requisitos Legales",
      sec4Text4:
        "Podremos compartir o transferir sus datos si lo requiere la ley, incluyendo:",
      sec4List3Item1:
        "Cumplimiento con órdenes judiciales o requerimientos legales",
      sec4List3Item2: "Protección de nuestros derechos, propiedad o seguridad",
      sec4List3Item3: "Prevenir fraudes o actividades ilícitas",

      sec4Sub5: "4.5. Control del Usuario",
      sec4Text5: "Usted tiene control total sobre sus datos:",
      sec4List4Item1:
        "Puede revocar el acceso en cualquier momento desde su cuenta de Google",
      sec4List4Item2:
        "Puede eliminar la integración desde su perfil en RepliKers",
      sec4List4Item3:
        "Al revocar, todos los tokens de acceso se eliminan inmediatamente",

      sec4Sub6: "4.6. Datos que Compartimos con Google",
      sec4Text6:
        "Compartimos con Google SOLO lo necesario para el funcionamiento de la integración:",
      sec4List5Item1:
        "Tokens de autenticación: Intercambiamos código OAuth2 por tokens de acceso",
      sec4List5Item2:
        "Solicitudes de API: Enviamos sus tokens para autenticar solicitudes a Gmail API",
      sec4Note3:
        "NO compartimos ningún dato adicional con Google más allá de lo requerido para el funcionamiento OAuth2 y las llamadas API autorizadas.",

      // Sección 5
      sec5Title: "5. Almacenamiento y Retención de Datos",
      sec5Sub1: "5.1. Almacenamiento",
      sec5Text1: "Almacenamos los siguientes datos:",
      sec5List1Item1:
        "Tokens de acceso: Mantenemos access_token y refresh_token en nuestra base de datos para mantener su conexión activa",
      sec5List1Item2:
        "Metadatos de Gmail: NO almacenamos los metadatos de correos en nuestra base de datos; solo se muestran temporalmente en su sesión",
      sec5List1Item3:
        "Perfil de usuario: Almacenamos su nombre, email y foto en su cuenta de usuario",

      sec5Sub2: "5.2. Retención y Eliminación",
      sec5List2Item1:
        "Tokens: Eliminados inmediatamente cuando revoca el acceso o elimina su cuenta",
      sec5List2Item2:
        "Metadatos de correos: No persisten; se borran al cerrar sesión",
      sec5List2Item3:
        "Perfil: Mantenidos hasta que elimina su cuenta o solicita su eliminación",

      // Sección 6
      sec6Title: "6. Seguridad de los Datos",
      sec6Text: "Implementamos múltiples capas de seguridad:",
      sec6ListItem1:
        "Encriptación en tránsito: Todas las comunicaciones usan HTTPS/TLS 1.3",
      sec6ListItem2:
        "Encriptación en reposo: Tokens de acceso encriptados en base de datos",
      sec6ListItem3:
        "Rotación de tokens: Refresh tokens actualizados automáticamente",
      sec6ListItem4:
        "Validación de sesiones: Sesiones gestionadas con cookies seguras HttpOnly",
      sec6ListItem5:
        "Control de acceso: Acceso mínimo necesario (principle of least privilege)",
      sec6ListItem6: "Auditoría: Logs de acceso monitoreados regularmente",

      // Sección 7
      sec7Title: "7. Sus Derechos",
      sec7Text: "Bajo GDPR y CCPA, usted tiene derecho a:",
      sec7List1Item1: "Acceso: Solicitar copia de sus datos personales",
      sec7List1Item2: "Rectificación: Corregir datos inexactos o incompletos",
      sec7List1Item3:
        "Eliminación: Solicitar la eliminación de sus datos ('derecho al olvido')",
      sec7List1Item4: "Portabilidad: Recibir sus datos en formato estructurado",
      sec7List1Item5: "Oposición: Oponerse al procesamiento de sus datos",
      sec7List1Item6:
        "Retirar consentimiento: Revocar permisos en cualquier momento",

      sec7Text2: "Cómo ejercer sus derechos:",
      sec7List2Item1: "Enviar solicitud a: ",
      sec7List2Item2: "Revocar acceso desde: ",
      sec7List2Item3:
        "Eliminar integración desde: Su perfil en RepliKers > Mensajería",

      // Sección 8
      sec8Title: "8. Contacto",
      sec8Text: "Si tiene preguntas sobre esta política, contáctenos en: ",
    },
    termsOfService: {
      backBtn: "← Volver al inicio",
      mainTitle: "Condiciones del Servicio",
      lastUpdate: "Última actualización: 05 de enero de 2026",

      sec1Title: "1. Aceptación de los Términos",
      sec1Text:
        "Al acceder y utilizar RepliKers, usted acepta quedar vinculado por estas Condiciones del Servicio y todas las leyes y reglamentos aplicables.",

      sec2Title: "2. Uso de la Plataforma",
      sec2Text:
        "RepliKers ofrece herramientas de automatización y gestión de mensajería. Usted se compromete a utilizar el servicio únicamente para fines lícitos y de acuerdo con estos términos.",

      sec3Title: "3. Cuentas e Integraciones",
      sec3Text:
        "Para utilizar ciertas funciones, como la lectura de notificaciones de Gmail, debe conectar sus cuentas de terceros. Usted es responsable de mantener la confidencialidad de sus credenciales y de todas las actividades que ocurran bajo su cuenta.",

      sec4Title: "4. Propiedad Intelectual",
      sec4Text:
        "Todo el contenido, características y funcionalidad de RepliKers son propiedad exclusiva de RepliKers y sus licenciantes.",

      sec5Title: "5. Limitación de Responsabilidad",
      sec5Text:
        "En ningún caso RepliKers será responsable de cualquier daño indirecto, incidental, especial, consecuente o punitivo que resulte de su acceso o uso del servicio.",

      sec6Title: "6. Modificaciones",
      sec6Text:
        "Nos reservamos el derecho de modificar estos términos en cualquier momento. El uso continuado del servicio después de dichos cambios constituye su aceptación de los nuevos términos.",
    },
    explore: {
      // Títulos de secciones
      trendingTitle: "Tendencias",
      suggestedUsersTitle: "Personas a seguir",
      replikersTitle: "Descubre Replikers",

      // Tabs
      tabTrending: "Tendencias",
      tabUsers: "Usuarios",
      tabReplikers: "Replikers",

      // Búsqueda
      searchPlaceholder: "Buscar usuarios, posts o hashtags...",
      searching: "Buscando...",
      searchResults: "Resultados de búsqueda",
      noResults: "No se encontraron resultados",

      // Estados
      loading: "Cargando contenido...",
      noBio: "Sin biografía",

      // Acciones
      chatNow: "Chatear ahora",
      viewProfile: "Ver perfil",
      followers: "seguidores",

      // Sidebar
      trendingHashtags: "Hashtags populares",
      popularReplikers: "Replikers populares",

      // Resultados de búsqueda
      resultsFound: "resultados encontrados",
      relatedPosts: "Posts relacionados",
      postsWithHashtag: "Posts con este hashtag",
      usersFound: "Usuarios encontrados",
      noPostsWithHashtag: "No hay posts con este hashtag",
      tryDifferentSearch: "Prueba con otros términos de búsqueda",
    },
  },

  // --- IDIOMA INGLÉS ---
  en: {
    home: {
      // <<-- NUEVAS CLAVES PARA HOME -->>
      heroLine1: "Welcome to the community of",
      heroWords: ["Consultants", "Talent", "Specialists", "Professionals"],
      heroLine3: "",
      exploreCommunity: "Explore the community",
      searchPlaceholder:
        "What problem do you need to solve? Write here and let Repli find the Specialist you need",
      dropzone: "Drop your PDF or JPG here to attach it",
      unsupportedFile:
        "Unsupported file type. Please upload PDF, JPG, or PNG files.",
      cancelRequest: "Cancellation requested, but not implemented.",
      errorConnect: "Sorry, I couldn't connect. Please try again.",
      thinking: "Thinking...",
      servicesTitle: "Our Services",
      servicesSubtitle: "Choose one of our services to start a quick search.",
      serviceCV: "CV Creation",
      serviceConsulting: "Business Consulting",
      // Discover Section
      discoverTitle: "Discover More",
      discoverBlogTitle: "News and Articles",
      discoverBlogDesc: "Explore the latest trends in AI and professional development on our blog.",
      discoverBlogBtn: "Go to Blog",
      discoverAboutTitle: "Know our Vision",
      discoverAboutDesc: "Understand how we are transforming the future of independent work.",
      discoverAboutBtn: "About Us",
      // Fabrica tu Repliker Section
      factoryTitle: "Ready to have your own Repliker?",
      factoryP1_1:
        "Transform your digital presence and amplify your voice. With a ",
      factoryP1_2:
        ", you can scale your knowledge and be available to your audience 24/7.",
      factoryP2_1: "Are you ready to create your own digital version?",
      factoryP2_2: "Take the first step to amplify your impact on the world!",
      factoryP3_1: "Expand your business or personal brand:",
      factoryP3_2:
        "A repliker can serve as your virtual assistant, an instant consultant, or a content creator with your personal stamp.",
      factoryP4:
        "Schedule a meeting with us to discover how we can create a digital replica of you.",
      factoryButton: "Build Your Repliker!",
    },
    header: {
      home: "Home",
      hire: "RepliKers Community",
      blog: "Blog",
      news: "News",
      about: "About Us",
      build: "Build your Repliker",
      community: "Community",
      social: "Social",
      profile: "Profile",
      logout: "Log Out",
      login: "Log In",
      messaging: "My messaging",
      // Accessibility texts
      openMenu: "Open menu",
      myProfileAlt: "My Profile",
    },
    footer: {
      // <<-- NUEVAS CLAVES PARA FOOTER -->>
      slogan: "Powering the future.",
      socialMedia: "Social Media",
      contactUs: "Contact Us",
      quickLinks: "Useful Shortcuts",
      replikersList: "Repliker list",
      blog: "Blog",
      social: "Social",
      aboutUs: "About Us",
      copyText: "All rights reserved.",
      company: "Conauti LATAM.",
      privacyPolicy: "Privacy Policy",
      termsOfService: "Terms of Service",
    },
    replikers: {
      mainTitle: "Our RepliKers",
      subtitle: "Find your ideal repliker.",
      tryNow: "Chat now",
      areaHR: "Human Resources & Talent Management",
      areaLegal: "Legal & Corporate Consulting",
      areaCareer: "Professional Development & Careers",
      areaProjectMgmt: "Project Management",
      areaEngineering: "Engineering",
      areaFinance: "Finance (Risk and Collections)",
      areaSoftware: "Software Development & AI",
      areaAIFounder: "AI Product Founder",
    },
    filtersReplikers: {
      areaLabel: "Area",
      applyButton: "Apply Filters",
      all: "All",
      generalist: "Generalist",
    },
    about: {
      // <<-- CLAVES PARA ABOUT PAGE -->>
      // Títulos principales
      whoWeAre: "Who We Are",
      forWho: "Who is Replikers For?",
      challengeProposal: "Why Replikers? The Challenge and Our Proposal",
      whatIsRepliker:
        "What is a Repliker? Your High-Performance Digital Replica",
      impact: "The Repliker Impact: Scale Your Services, Not Your Hours",
      visionMission: "Our Vision, Mission, and Your Next Step",

      // Contenido - Quiénes Somos
      whoWeAreP1_1:
        "At RepliKers, we are building the IA First Operating System that every professional looking for independence needs to achieve exponential growth. Founded in August 2024, our mission is to transform your knowledge into an intelligent digital replica capable of automating sales, marketing, and customer service. By integrating tools like Google (Gmail), we allow your replica to efficiently manage your professional communication with fast and personalized responses, boosting your impact as an independent professional without compromising data privacy.",

      // Contenido - Para Quién
      forWhoP1:
        "Our system is designed for the high-value expert who seeks to grow and scale their impact without sacrificing their personal life.",
      proTitle: "The Independent Professional:",
      proP1:
        "If you already have proven expertise and want to multiply your income and reach without compromising your personal time, Replikers is your ally.",
      founderTitle: "The Future Founder of a Boutique Consulting Firm:",
      founderP1:
        "Those looking to transform their individual knowledge into a highly scalable and automated boutique service company, ready to dominate in the age of Artificial Intelligence.",
      challengeP1:
        "We understand the challenge: 'I can't grow more without sacrificing my personal life.' Operational tasks (sales, marketing, administration) consume the time you should be dedicating to delivering real value to your clients.",

      // Contenido - Desafío y Propuesta
      problemTitle: "The Core Problem: Linear and Exhausting Growth",
      problemL1: "Professional growth is often linear, slow, and painful.",
      problemL2:
        "You are investing valuable time in repetitive operational tasks (commercial, marketing, and administrative), which prevents you from scaling your business beyond your available hours and compromises the consistency of your service.",
      opportunityTitle: "Our Opportunity: From Linear to Exponential",
      opportunityP1_1:
        "Replikers turns your experience and your time into a 24/7 Digital Asset that works tirelessly for you. We move you from a linear business model to an exponential one, scaling your methodology and not just your work hours.",

      // Contenido - Qué es un Repliker
      whatIsP1:
        "A Repliker is your IA First Operating System: an intelligent extension, empowered by your knowledge and trained specifically in your methodology to drive your independent growth.",
      whatIsP2:
        "Essentially, it is a hyper-specialized sales and service assistant that carries your name, trained solely in your processes and philosophy.",
      componentsTitle: "Key Components:",
      componentL1Title: "Hyper-Specialization (Unique DNA):",
      componentL1Desc:
        "Built with Fine Tuning and Retrieval-Augmented Generation (RAG) over your unique data (playbooks, insights, templates), your Repliker adopts your personality. It is not a generic IA agent; it is the only one capable of delivering your service exactly as you would.",
      componentL2Title: "Autonomous Functionality:",
      componentL2Desc:
        "Trained to Observe, Reason, and Act, your Repliker connects to your key tools (Google Calendar, email, WhatsApp, social media) to execute complete workflows. This means it can perform unsupervised tasks, from finding leads to managing your unified inbox.",
      componentL3Title: "Smart Monetization Strategy:",
      componentL3Desc:
        "Your Repliker can offer consultations, execute tasks, or schedule personalized advice, automatically charging before delivering the service. This generates passive income through multiple sources: consultations, specific tasks, advertising, and community traffic.",

      // Contenido - Impacto
      impactP1_1:
        "Your Repliker is the engine that orchestrates and automates the growth of your independent professional business, allowing you to ",
      impactP1_2: "scale your services, not your hours.",
      impactP1_3:
        "We specialize in empowering independent consultants, freelancers, and in the creation of boutique consulting firms.",
      benefitsTitle: "Key Benefits:",
      benefitL1Title: "24/7 Sales and Marketing:",
      benefitL1Desc:
        "Your Repliker attends to and qualifies every lead from your social media, WhatsApp, or email. It is your tireless sales advisor, automatically creating and managing your sales funnel.",
      benefitL2Title: "Guaranteed Scalability:",
      benefitL2Desc:
        "Amplify your reach globally, available 24 hours a day, 7 days a week, in any language. It maintains consistent result quality without consuming your personal hours.",
      benefitL3Title: "IA Shielding:",
      benefitL3Desc:
        "It provides you with a unique competitive advantage. Instead of competing against generic IA agents, you use your Repliker to multiply your efficiency, speed, and data analysis capability.",
      benefitL4Title: "Enhanced Professional Image:",
      benefitL4Desc:
        "It projects a consistent, accurate, and cutting-edge representation of your expertise, elevating your personal brand as a leader who dominates Artificial Intelligence.",
      benefitL5Title: "Superpowers:",
      benefitL5Desc:
        "Acquire the superpowers of a digital asset: 24/7 Availability, Unlimited Scalability, Unprecedented Execution Speed, and Competitive Pricing.",
      benefitL6Title: "Unified and Intelligent Inbox:",
      benefitL6Desc:
        "Receive all communications from your leads unified and filtered by your Repliker. You will only see what is important, and your Repliker will always respond to the essential and urgent.",
      benefitL7Title: "Active Job Search:",
      benefitL7Desc:
        "If desired, your Repliker can proactively search for traditional job opportunities, optimizing your possibilities.",

      // Contenido - Visión y Misión
      visionTitle: "Vision:",
      visionP1:
        "To be the leading global IA FIRST Operating System, scaling professional knowledge and transforming it into fully automated Boutique Service Companies or Independent Professional Services, eliminating the pain of scale through IA.",
      missionTitle: "Mission:",
      missionP1:
        "To create an IA FIRST-driven operating system that executes and orchestrates all commercial, marketing, and administrative tasks that an independent professional needs to grow and scale.",
      competitiveTitle: "Our Competitive Advantage:",
      competitiveP1:
        "The complete automation of all tasks (commercial, marketing, administrative) that an independent professional needs to grow, centered on their unique knowledge and expertise.",
      readyForFutureTitle: "Ready for the Future?",
      readyForFutureP1_1:
        "If you are ready to stop selling your hours and start selling your digital asset, schedule a meeting now to start building your Repliker:",
      scheduleLink: "https://bit.ly/CitaRepliker",
    },
    chat: {
      replikerNotFound: "Repliker not found.",
      emptyChatPrompt: "How can I help you today?",
      loginPrompt: "Please log in to chat.",

      // Indicadores de estado de la IA
      thinking: "Thinking...",
      thinkingMoment: "Just a moment...",
      thinkingRefining: "Refining...",

      // Manejo de errores y acciones
      errorDefault: "Sorry, an error occurred.",
      newChat: "New Chat",
      noActiveConversation: "No active conversation to send the message.",
      requestCanceled: "Request canceled by the user.",

      // Drag & Drop
      dropzone: "Drop your PDF or JPG here to attach it",
      unsupportedFile:
        "Unsupported file type. Please upload PDF, JPG, or PNG files.",

      // Sidebar
      newConversationButton: "New Conversation",
    },
    chatComponent: {
      // ProfileSidebar
      share: "Share",
      historyTitle: "Chat History",
      newConversationButton: "+ New Conversation",
      updateError: "Failed to update chat name.",
      userLabel: "You",
      botLabel: "Bot",

      // ChatMessage (Archivos)
      fileDefaultName: "File",
      fileAttachedLabel: "Attached file:",
      imageAlt: "Attachment",
      viewLink: "View link",

      // AudioRecordModal
      modalTitle: "Record Audio",
      closeButtonLabel: "Close",
      statusIdle: "Press to record",
      statusRecording: "Recording...",
      statusRecorded: "Audio recorded",
      buttonRecord: "Record",
      buttonStop: "Stop",
      buttonRecordAgain: "Record again",
      buttonCancel: "Cancel",
      buttonSend: "Send",
      errorMicrophoneAccess:
        "Could not access the microphone. Verify permissions.",
      errorRecordingStop: "An error occurred while stopping the recording.",

      // ConversationBar (Input/Placeholder/Botones)
      filePreviewAlt: "File preview",
      attachFileTitle: "Attach file",
      attachFileLabel: "Attach file",
      recordAudioTitle: "Record audio",
      recordAudioLabel: "Record audio",
      placeholderThinking: "Awaiting response...",
      placeholderDefault: "Ask anything you want",
      stopButtonAlt: "Stop",
    },
    blog: {
      // Títulos y mensajes de estado
      heroTitle: "Check out our blog",
      loading: "Loading blogs...",

      // Botones y acciones
      readArticle: "Read article",

      // Mensajes de error/verificación (Modales)
      verificationError: "Incorrect verification code.",
      verificationErrorGeneral: "Error verifying code.",

      // Accesibilidad
      heroAlt: "Blog hero background",
    },
    editBlog: {
      modalTitle: "Edit Blog",
      titleLabel: "Title:",
      dateLabel: "Date:",
      imageUrlLabel: "Image URL:",
      contentLabel: "Content (Markdown):",
      updateButton: "Update Blog",

      // Mensajes de estado
      updating: "Updating blog...",
      success: "Blog updated successfully!",
      errorDefault: "Could not update the blog.",
      errorPrefix: "Error:",
    },
    blogPost: {
      loading: "Loading article...",

      // Mensajes de error
      notFoundTitle: "Article not found",

      // Enlaces
      backToBlog: "Back to blog",
      backToBlogList: "Back to blog list",

      // Etiquetas
      publicationDate: "Publication date:",
      relatedBlogsTitle: "Related articles",
    },
    notifications: {
      like: "{name} liked your post",
      follow: "{name} started following you",
      comment: "{name} commented on your post",
      reply: "{name} replied to your comment",
      mention: "{name} mentioned you in a post",
      default: "{name} interacted with you",
    },
    social: {
      // General & Sidebar
      headerTitle: "Social",
      navHome: "Home",
      navExplore: "Explore",
      navNotifications: "Notifications",
      navFollowing: "Following",
      navMessages: "Messages",
      navProfile: "Profile",
      navPostBtn: "Post",
      whatsHappening: "What's happening",

      // ChatPage
      loading: "Loading...",
      loadingChat: "Loading chat...",
      noConversationsTitle: "No messages yet",
      noConversationsText: "Send a message to start a conversation.",
      clearChat: "Clear chat",
      deleteConversation: "Delete conversation",
      selectMessageTitle: "Select a message",
      selectMessageText:
        "Choose from your existing conversations, start a new one, or just keep swimming.",
      newMessageBtn: "New message",
      newMessageModalTitle: "New message",
      nextBtn: "Next",
      noPeopleFound: "No people found",

      // ExplorePage
      exploreTitle: "Explore",
      newContentTitle: "New content coming soon!",
      newContentText: "We are working on new ways to discover content.",

      // PostFeed & PostDetail
      postHeader: "Post",
      loadMore: "Load more",
      feedEnd: "No more posts",
      feedEmpty: "No posts yet",

      // CreatePost
      loginToShare: "Log in to share your thoughts...",
      createPostPlaceholder: "What is happening?!",
      postingBtn: "Posting...",
      postBtn: "Post",

      // CommentSection
      loadingComments: "Loading comments...",
      editBtn: "Edit",
      deleteBtn: "Delete",
      saveBtn: "Save",
      cancelBtn: "Cancel",
      addCommentPlaceholder: "Add a comment...",
      replyingTo: "Replying to",

      // NotificationsPage
      notificationsTitle: "Notifications",
      loginNotifTitle: "Log in to see notifications",
      loginNotifText:
        "Join the conversation to see who is interacting with you.",
      loginBtn: "Log in",
      noNotificationsTitle: "No notifications yet",
      noNotificationsText:
        "When someone likes your post or follows you, you'll see it here.",

      // PostItem (New flat additions)
      postShareMsgPrefix: "I want to talk more about:",
      postShareMsgImg: "this image/video",
      postShareMsgPost: "this post",
      postSharedFrom: "Shared post from",
      postFollow: "Follow",
      postFollowing: "Following",
      postEdit: "Edit",
      postDelete: "Delete",
      postDeleteConfirm: "Are you sure you want to delete this post?",
      postShareVia: "Share via",
      postCopyLink: "Copy link",
      postSendTo: "Talk to repliker",
      postLinkCopied: "Link copied to clipboard!",
      postEditError: "Failed to edit post",
      postDeleteError: "Error deleting post",
      postReadMore: "Read more",
      postShowLess: "Show less",
      postSave: "Save",
      postCancel: "Cancel",
      postCommentedLabel: "Commented",
      postTooltipMore: "More options",
      postTooltipReply: "Reply",
      postTooltipShare: "Share",
      postTooltipLike: "Like",
      postTooltipViews: "Views",
      postTooltipSendRepliker: "Talk to repliker",

      // Repli Post + Blog
      repliGenerateBlog: "Do you also want me to generate an SEO blog for your website?",
      repliGenerateBlogYes: "Yes, generate blog!",
      repliGenerateBlogNo: "Only post",
      repliPublishing: "Publishing...",
      repliPostPublished: "Post published!",
      repliBlogPublished: "Blog published!",
      repliBothPublished: "Post and blog published!",
      repliPublishError: "Error publishing",
      repliEditPost: "Edit post",
      repliEditBlog: "Edit blog",
      repliPublish: "Publish",
      repliBlogTitle: "Blog title",
      repliBlogContent: "Blog content",
      repliBlogImageUrl: "Image URL",

      // SocialProfilePage
      profileCheckOut: "Check out {name}'s profile on Replikers!",
      profileLinkCopied: "Profile link copied to clipboard!",
      profileUserNotFound: "User not found",
      profilePostsCount: "posts",
      profileAddCover: "Add cover photo",
      profileEditBtn: "Edit Profile",
      profileShareTooltip: "Share Profile",
      profileBioPlaceholder: "Add description",
      profileStatsFollowing: "Following",
      profileStatsFollowers: "Followers",
      profileTabPosts: "Posts",
      profileTabReplies: "Replies",
      profileRepliedTo: "Replied to",
      profileNoPosts: "No posts yet",
      profileNoReplies: "No replies yet",
      profileComingSoon: "Coming soon",

      // Edit Profile Modal
      profileModalTitle: "Edit Profile",
      profileLabelName: "Name",
      profileLabelUsername: "Username",
      profileLabelBio: "Bio",
      profileInputBioPlaceholder: "Add a bio to your profile",
      profileSaving: "Saving...",
      profileSave: "Save",
      profileUpdateError: "Error updating profile",

      // UserSearch
      searchPlaceholder: "Search",
      searchNoResults: "No results found",
      searchOwnersTitle: "Our Replikers",
      searchOwnersSubtitle: "Discover what's new from our replikers",
    },
    profile: {
      // Tabs
      myAccount: "My Account",
      myPurchases: "My Purchases",
      myRepliker: "MY REPLIKER",
      myMessaging: "My messaging",
      addContent: "ADD CONTENT",
      settings: "Settings",
      uploadedFiles: "Uploaded files",
      returnToChat: "Return to chat",
      // Mi Cuenta
      myProfileTitle: "My Profile",
      changePhoto: "Change photo",
      loading: "Loading...",
      logout: "Log out",
      personalInfo: "Personal Information",
      edit: "Edit",
      country: "Country",
      selectCountry: "Select a country",
      phone: "Phone Number",
      update: "Update",
      cancel: "Cancel",
      notAvailable: "Not available",
      saved: "Profile updated!",
      errorSave: "Error updating.",
      name: "Name",
      displayNameLabel: "Display Name:",
      displayNamePlaceholder: "Your name Complete",
      professionLabel: "ROLE / POSITION / PROFESSION:",
      professionPlaceholder: "e.g., Software Engineer (Required for your Repliker)",
      areaLabel: "Area / Category:",
      selectCategory: "Select a category (Required for your Repliker)",
      // Mis Compras
      historyPurchases: "Purchase History",
      historyPurchasesDesc:
        "If you made purchases or acquired services and they don't appear here, don't worry, we are working on it.",
      // Dashboard
      dashboardTitle: "My Repliker Dashboard",
      chatHistory: "Conversation History",
      recentConvs: "Recent Conversations:",
      loadingHistory: "Loading conversation history...",
      noHistory: "No recent conversations for your Repliker.",
      session: "Session",
      with: "with",
      userLabel: "User",
      replikerLabel: "Repliker",
      noMessages: "No messages in this session.",
      seeFullHistory: "See Full History",
      // Subtabs
      aiAnalysis: "AI Analysis",
      summary: "Summary",
      // Analysis Section
      analysisBadge: "Insights Analysis",
      analysisDesc: "Ask your Repliker about your post performance, interactions, and audience behavior.",
      resetAnalysis: "Reset Analysis",
      analysisReady: "Your data assistant is ready. What would you like to analyze today?",
      analysisPlaceholder: "e.g., What type of content generated the most comments this month?",
      clearChat: "Clear Conversation",
      activeAgent: "Active Agent",
      days7: "7 Days",
      days30: "30 Days",
      months3: "3 Months",
      viewsTrend: "Views Trend",
      interactionPeaks: "Interaction Peaks",
      conversionFunnel: "Conversion Funnel",
      noText: "No text",
      searchById: "Search by ID...",
      sessionId: "Session ID",
      fullTranscript: "Full Transcript",
      downloadTxt: "Download TXT",
      noMessagesInConv: "No messages in this conversation.",
      highRelation: "High Relation",
      file: "File",
      view: "View",
      noFilesUploaded: "No files uploaded yet.",
      addPostPlaceholder: "Describe the content you want to create or attach a file...",
      // Mi mensajeria
      menssagingTitle: "My messaging",
      menssagingSubtitle: "Centralize your Gmail and LinkedIn notifications in one place.",
      providerGmail: "Google Gmail",
      providerLinkedIn: "LinkedIn",
      connectGmail: "Connect Gmail",
      connectLinkedIn: "Connect LinkedIn",
      unifiedInbox: "Unified Inbox",
      loadingNotifs: "Loading notifications...",
      noNotifs: "You have no pending notifications.",
      notifFromLabel: "From:",
      notifCloseBtn: "Close",
      notifDisclaimer: "Note: This is a preview of the unified message.",
      errorLoadNotifs: "Error loading notifications. Make sure to connect your accounts.",
      errorConnectGoogle: "Error starting Google connection.",
      errorConnectLinkedIn: "Error starting LinkedIn connection.",
      // Añade contenido
      addPostTitle: "Add content with Repli",
      addPostText:
        "Describe the content you want to upload or attach a file for Repli to process.",
      addPostEmptyChatMsg: "What content would you like to add today?",
      creativeStudio: "Creative Studio",
      templateSocial: "Social Post",
      templateBlog: "Blog Article",
      templateVideo: "Video Script",
      templateNewsletter: "Newsletter",
      // Settings
      theme: "Theme",
      dark: "Dark",
      light: "Light",
      language: "Language",
      spanish: "Spanish",
      english: "English",
      portuguese: "Portuguese",
      // Tooltips for Insights
      infoViewsTrend: "Shows the evolution of the number of views of your content over the selected period.",
      infoInteractionPeaks: "Identifies the moments with the highest number of interactions (likes, comments, shares) on your posts.",
      infoConversionFunnel: "Visualizes the user's journey from seeing your content to starting a conversation with your Repliker.",
      infoTotalViews: "Total number of times your posts have been viewed by users.",
      infoTotalPosts: "Total number of contents you have published on the platform.",
      infoTotalInteractions: "Total sum of likes, comments, and shares of your content.",
      infoConvsStarted: "Number of times a user has started a chat directly with your Repliker from your content.",
      infoAvgDwellTime: "Average time users spend viewing your posts.",
      comingSoon: "New languages/themes coming soon.",
      // Insights
      insightsTitle: "Performance Insights",
      insightsSummary: "Performance Summary",
      totalPosts: "Total Posts",
      totalViews: "Total Views",
      totalInteractions: "Total Interactions",
      convsStarted: "Conversations Started",
      postDetails: "Post Details",
      interactions: "Interactions",
      views: "Views",
      comments: "Comments",
      shares: "Shares",
      avgDwellTime: "Average Dwell Time",
      dwellTime: "Dwell Time",
      ctrActions: "CTR / Actions",
      showMore: "Show more",
      showLess: "Show less",
      // CRM
      crmTab: "CRM",
      crmTitle: "Contact Management (Leads)",
      crmDesc: "Here you can find the data captured by your Repliker when a user provides their information.",
      colName: "Name",
      colEmail: "Email",
      colPhone: "Phone",
      colRole: "Role",
      colCompany: "Company",
      colService: "Service of Interest",
      colDetails: "Problem Details",
      colStatus: "Status",
      colFollowups: "Follow-ups",
      actionFollowup: "Follow-up",
      // New CRM columns
      colContactType: "Contact Type",
      colWebsite: "Website",
      colAddress: "Address",
      colCity: "City",
      colCountry: "Country",
      colLinkedin: "LinkedIn",
      colEmailPref: "Email Pref.",
      colOrigin: "Origin",
      colLastContact: "Last Contact",
      colDate: "Capture Date",
      colNotes: "Internal Notes",
      noLeads: "No leads captured yet.",
      loadingLeads: "Loading contacts...",
      becomeOwnerSuccessMsgShort: "Account Owner activated",
      becomeOwnerRevoked: "Owner Account revoked. Contact support: +1 (415) 604-6499 | hola@replikers.com",
      createOrEditRepliker: "Create or Edit your Repliker",
      missingFieldsError: "Missing fields to complete.",

      // Guest Restricted
      guestRestrictedTitle: "Limited Access",
      guestRestrictedDesc: "As a guest, you cannot customize your profile or access advanced features. Sign up to unlock all tools.",
    },
    verificationModal: {
      modalTitle: "Verification Required",
      descriptionP1:
        "To edit this article, please enter the verification code:",
      placeholder: "Verification code",
      buttonVerify: "Verify",
    },
    repli: {
      placeholder: "Type your message...",
      buttonSend: "Send",
      errorDefault: "Sorry, I couldn't process your request.",
      errorContact: "Error contacting the Repli agent:",
    },
    login: {
      welcomeTitle: "Welcome to the Replikers community",
      loginHeader: "Log in with",
      loginButtonGoogle: "Log in with Google",
      loginButtonEmail: "Log in with Email",
      guestButton: "Continue as Guest",
      braveWarningBold: "Using Brave?",
      braveWarningText:
        "If Google login fails, temporarily disable Shields (lion icon) for this site.",
      privacyMessage:
        "We only use your Google account for authentication. We do not access private information.",
      poweredBy: "Powered by Conauti",
      guestError: "Could not log in as a guest. Please try again.",
      googleLogoAlt: "Google Logo",
      emailLogoAlt: "Email Logo",
      userLogoAlt: "User Logo",
      registerSuccess: "Successful registration",

      // LoginForm
      loginTitle: "Log in to",
      emailPlaceholder: "Email Address",
      passwordPlaceholder: "Password",
      loginButton: "Log In",
      loadingButton: "Logging in...",
      errorSession: "Failed to log in to the server. Please try again.",
      errorVerificationNeeded:
        "Your email has not been verified. Please check your inbox.",
      errorLoginFailed: "An error occurred while logging in.",
      errorInvalidCredentials: "The email or password are incorrect.",
      errorInvalidEmailFormat: "The email format is invalid.",
      resendButton: "Resend verification email",
      resendSuccess:
        "The verification email has been resent. Please check your inbox.",
      resendError:
        "Could not resend the verification email. Please try again later.",
      toggleRegister: "Don't have an account? Sign up",

      // RegisterForm
      registerTitle: "Sign up for",
      confirmPasswordPlaceholder: "Confirm Password",
      registerButton: "Register",
      errorPasswordMismatch: "Passwords do not match.",
      errorPasswordLength: "Password must be at least 6 characters long.",
      errorRegisterFailed: "An error occurred during registration.",
      errorEmailInUse: "The email address is already in use.",
      errorInvalidEmail: "The email address is invalid.",
      errorWeakPassword: "The password is too weak.",
      registerSuccessAlert:
        "Successful registration! A verification email has been sent to your email address. Please verify your email before logging in.",
      toggleLogin: "Already have an account? Log in",
    },
    privacyPolicy: {
      backBtn: "← Back to home",
      mainTitle: "Privacy Policy",
      lastUpdate: "Last updated: January 05, 2026",

      // Section 1
      sec1Title: "1. Introduction",
      sec1Text:
        "At RepliKers, user privacy is our priority. This policy details how we collect, use, and protect your information when you use our platform and, specifically, our integration with Google services.",

      // Section 2
      sec2Title: "2. Google Data We Collect",
      sec2Sub1: "2.1. Google OAuth2 Authentication",
      sec2Text1: "When you log in with Google, we access:",
      sec2List1Item1: "Email: Your email address to identify your account",
      sec2List1Item2: "Name: Your full name to personalize your experience",
      sec2List1Item3:
        "Profile picture: URL of your photo to display on your profile",
      sec2List1Item4: "Google ID: Unique identifier to link your account",

      sec2Sub2: "2.2. Gmail API Integration",
      sec2Text2: "When you connect your Gmail account, we access:",
      sec2List2Item1:
        "Unread emails: Metadata (subject, sender, date) of the last 10 unread emails",
      sec2List2Item2:
        "Content snippet: A brief summary (snippet) of each email for preview",
      sec2List2Item3: "Identifiers: Unique ID of each message for tracking",
      sec2List2Item4:
        "Access tokens: access_token and refresh_token to keep the connection active",
      sec2Important:
        "Important: We DO NOT access the full content of your emails, only metadata for notifications.",

      // Section 3
      sec3Title: "3. How We Use Google Data",
      sec3Sub1: "3.1. Authentication Data",
      sec3Text1: "We use your authentication data to:",
      sec3List1Item1: "Create and manage your user account on RepliKers",
      sec3List1Item2: "Log in securely without a password",
      sec3List1Item3:
        "Personalize your experience with your name and profile picture",
      sec3List1Item4: "Uniquely identify you in our system",

      sec3Sub2: "3.2. Gmail Data",
      sec3Text2: "We use Gmail data exclusively to:",
      sec3List2Item1:
        "Show notifications: Display unread emails in your messaging dashboard",
      sec3List2Item2:
        "Unify communications: Centralize your professional alerts in one place",
      sec3List2Item3:
        "Real-time update: Reflect the current status of your inbox",

      sec3ComplianceTitle: "Compliance with Google Limited Use Policy:",
      sec3ComplianceItem1: "We DO NOT use your Gmail data for advertising",
      sec3ComplianceItem2:
        "We DO NOT sell, rent, or share your data with advertisers",
      sec3ComplianceItem3:
        "We DO NOT use your data to train external AI models",
      sec3ComplianceItem4: "We DO NOT store the full content of your emails",
      sec3GooglePolicyLink: "Google API Services User Data Policy",
      sec3GooglePolicyText:
        "The use of information received from Google APIs will adhere strictly to the Google API Services User Data Policy, including the Limited Use requirements.",

      // Section 4
      sec4Title: "4. Who We Share Google Data With",
      sec4Sub1:
        "4.1. We DO NOT Share Your Data with Third Parties for Advertising",
      sec4Text1:
        "RepliKers DOES NOT sell, rent, or transfer your Google data to third parties for marketing or advertising purposes.",

      sec4Sub2: "4.2. Essential Service Providers",
      sec4Text2:
        "We may share your data only with the following essential service providers who help us operate our platform:",
      sec4List1Item1:
        "Google Cloud Platform: For secure storage of access tokens (server)",
      sec4List1Item2:
        "Google OAuth2: For secure authentication (token exchange only)",
      sec4Note1:
        "These providers are prohibited from using your data for any purpose other than providing services to RepliKers.",

      sec4Sub3: "4.3. Authorized Personnel",
      sec4Text3: "Only authorized RepliKers personnel can access your data to:",
      sec4List2Item1:
        "Provide technical support when you explicitly request it",
      sec4List2Item2: "Perform system maintenance and debugging",
      sec4List2Item3: "Investigate suspicious activities or security incidents",
      sec4Note2:
        "All access by personnel is monitored and subject to strict confidentiality agreements.",

      sec4Sub4: "4.4. Legal Requirements",
      sec4Text4:
        "We may share or transfer your data if required by law, including:",
      sec4List3Item1: "Compliance with court orders or legal requirements",
      sec4List3Item2: "Protection of our rights, property, or safety",
      sec4List3Item3: "Preventing fraud or illicit activities",

      sec4Sub5: "4.5. User Control",
      sec4Text5: "You have full control over your data:",
      sec4List4Item1:
        "You can revoke access at any time from your Google account",
      sec4List4Item2:
        "You can remove the integration from your RepliKers profile",
      sec4List4Item3:
        "Upon revocation, all access tokens are deleted immediately",

      sec4Sub6: "4.6. Data We Share with Google",
      sec4Text6:
        "We share with Google ONLY what is necessary for the integration to function:",
      sec4List5Item1:
        "Authentication tokens: We exchange OAuth2 code for access tokens",
      sec4List5Item2:
        "API Requests: We send your tokens to authenticate requests to Gmail API",
      sec4Note3:
        "We DO NOT share any additional data with Google beyond what is required for OAuth2 operation and authorized API calls.",

      // Section 5
      sec5Title: "5. Data Storage and Retention",
      sec5Sub1: "5.1. Storage",
      sec5Text1: "We store the following data:",
      sec5List1Item1:
        "Access tokens: We keep access_token and refresh_token in our database to maintain your active connection",
      sec5List1Item2:
        "Gmail Metadata: We DO NOT store email metadata in our database; it is only shown temporarily in your session",
      sec5List1Item3:
        "User profile: We store your name, email, and photo in your user account",

      sec5Sub2: "5.2. Retention and Deletion",
      sec5List2Item1:
        "Tokens: Deleted immediately when you revoke access or delete your account",
      sec5List2Item2: "Email metadata: Do not persist; cleared upon logout",
      sec5List2Item3:
        "Profile: Maintained until you delete your account or request its deletion",

      // Section 6
      sec6Title: "6. Data Security",
      sec6Text: "We implement multiple layers of security:",
      sec6ListItem1:
        "Encryption in transit: All communications use HTTPS/TLS 1.3",
      sec6ListItem2: "Encryption at rest: Access tokens encrypted in database",
      sec6ListItem3: "Token rotation: Refresh tokens automatically updated",
      sec6ListItem4:
        "Session validation: Sessions managed with secure HttpOnly cookies",
      sec6ListItem5:
        "Access control: Minimum necessary access (principle of least privilege)",
      sec6ListItem6: "Audit: Access logs monitored regularly",

      // Section 7
      sec7Title: "7. Your Rights",
      sec7Text: "Under GDPR and CCPA, you have the right to:",
      sec7List1Item1: "Access: Request a copy of your personal data",
      sec7List1Item2: "Rectification: Correct inaccurate or incomplete data",
      sec7List1Item3:
        "Deletion: Request deletion of your data ('right to be forgotten')",
      sec7List1Item4: "Portability: Receive your data in a structured format",
      sec7List1Item5: "Objection: Object to the processing of your data",
      sec7List1Item6: "Withdraw consent: Revoke permissions at any time",

      sec7Text2: "How to exercise your rights:",
      sec7List2Item1: "Send request to: ",
      sec7List2Item2: "Revoke access from: ",
      sec7List2Item3:
        "Remove integration from: Your Profile in RepliKers > Messaging",

      // Section 8
      sec8Title: "8. Contact",
      sec8Text: "If you have questions about this policy, contact us at: ",
    },
    termsOfService: {
      backBtn: "← Back to home",
      mainTitle: "Terms of Service",
      lastUpdate: "Last updated: January 05, 2026",

      sec1Title: "1. Acceptance of Terms",
      sec1Text:
        "By accessing and using RepliKers, you agree to be bound by these Terms of Service and all applicable laws and regulations.",

      sec2Title: "2. Use of the Platform",
      sec2Text:
        "RepliKers offers automation and messaging management tools. You agree to use the service only for lawful purposes and in accordance with these terms.",

      sec3Title: "3. Accounts and Integrations",
      sec3Text:
        "To use certain features, such as reading Gmail notifications, you must connect your third-party accounts. You are responsible for maintaining the confidentiality of your credentials and for all activities that occur under your account.",

      sec4Title: "4. Intellectual Property",
      sec4Text:
        "All content, features, and functionality of RepliKers are the exclusive property of RepliKers and its licensors.",

      sec5Title: "5. Limitation of Liability",
      sec5Text:
        "In no event shall RepliKers be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your access to or use of the service.",

      sec6Title: "6. Modifications",
      sec6Text:
        "We reserve the right to modify these terms at any time. Continued use of the service after such changes constitutes your acceptance of the new terms.",
    },
    explore: {
      // Section titles
      trendingTitle: "Trending",
      suggestedUsersTitle: "People to follow",
      replikersTitle: "Discover Replikers",

      // Tabs
      tabTrending: "Trending",
      tabUsers: "Users",
      tabReplikers: "Replikers",

      // Search
      searchPlaceholder: "Search users, posts or hashtags...",
      searching: "Searching...",
      searchResults: "Search results",
      noResults: "No results found",

      // States
      loading: "Loading content...",
      noBio: "No bio",

      // Actions
      chatNow: "Chat now",
      viewProfile: "View profile",
      followers: "followers",

      // Sidebar
      trendingHashtags: "Trending hashtags",
      popularReplikers: "Popular Replikers",

      // Search results
      resultsFound: "results found",
      relatedPosts: "Related posts",
      postsWithHashtag: "Posts with this hashtag",
      usersFound: "Users found",
      noPostsWithHashtag: "No posts with this hashtag",
      tryDifferentSearch: "Try different search terms",
    },
  },

  // --- IDIOMA PORTUGUÉS ---
  pt: {
    home: {
      heroLine1: "Bem-vindo à comunidade de",
      heroWords: ["Consultores", "Talento", "Especialistas", "Profissionais"],
      heroLine3: "",
      exploreCommunity: "Explorar a comunidade",
      searchPlaceholder:
        "Qual problema você precisa resolver? Escreva aqui e deixe o Repli encontrar o Especialista que você precisa.",
      dropzone: "Solte seu PDF ou JPG aqui para anexar",
      unsupportedFile:
        "Tipo de arquivo não suportado. Por favor, envie arquivos PDF, JPG ou PNG.",
      cancelRequest: "Cancelamento solicitado, mas não implementado.",
      errorConnect: "Desculpe, não foi possível conectar. Tente novamente.",
      thinking: "Pensando...",
      servicesTitle: "Nossos serviços",
      servicesSubtitle: "Escolha um dos nossos para iniciar uma busca rápida.",
      serviceCV: "Criação de CV",
      serviceConsulting: "Consultoria empresarial",
      // Discover Section
      discoverTitle: "Descubra mais",
      discoverBlogTitle: "Novidades e Artigos",
      discoverBlogDesc: "Explore as últimas tendências em IA e desenvolvimento profissional em nosso blog.",
      discoverBlogBtn: "Ir para o Blog",
      discoverAboutTitle: "Conheça nossa Visão",
      discoverAboutDesc: "Entenda como estamos transformando o futuro do trabalho independente.",
      discoverAboutBtn: "Sobre Nós",
      // Fabrica tu Repliker Section
      factoryTitle: "Pronto para ter seu próprio Repliker?",
      factoryP1_1:
        "Transforme sua presença digital e amplifique sua voz. Com um ",
      factoryP1_2:
        ", você pode escalar seu conhecimento e estar disponível para seu público 24/7.",
      factoryP2_1: "Você está pronto para criar sua própria versão digital?",
      factoryP2_2: "Dê o primeiro passo para ampliar seu impacto no mundo!",
      factoryP3_1: "Expanda seu negócio ou marca pessoal:",
      factoryP3_2:
        "Um repliker pode servir como seu assistente virtual, um consultor instantâneo ou um criador de conteúdo com sua marca pessoal.",
      factoryP4:
        "Agende uma reunião conosco para descobrir como podemos criar uma réplica digital de você.",
      factoryButton: "Crie Seu Repliker!",
    },
    header: {
      home: "Início",
      hire: "Comunidade RepliKers",
      blog: "Blog",
      news: "Notícias",
      about: "Sobre Nós",
      build: "Crie seu Repliker",
      community: "Comunidade",
      social: "Social",
      profile: "Perfil",
      logout: "Sair",
      login: "Entrar",
      // Textos para accesibilidad (alt y aria-labels)
      openMenu: "Abrir menu",
      myProfileAlt: "Meu Perfil",
    },
    footer: {
      slogan: "Impulsionando o futuro.",
      socialMedia: "Redes sociais",
      contactUs: "Contate-nos",
      quickLinks: "Atalhos úteis",
      replikersList: "Lista de replikers",
      blog: "Blog",
      social: "Social",
      aboutUs: "Sobre Nós",
      copyText: "Todos os direitos reservados.",
      company: "Conauti LATAM.",
    },
    replikers: {
      mainTitle: "Nossos RepliKers",
      subtitle: "Encontre seu repliker ideal.",
      tryNow: "Converse agora",
      areaHR: "Recursos Humanos e Gestão de Talentos",
      areaLegal: "Consultoria Jurídica e Corporativa",
      areaCareer: "Desenvolvimento Profissional e Carreira",
      areaProjectMgmt: "Gestão de Projetos",
      areaEngineering: "Engenharia",
      areaFinance: "Finanças (Risco e Cobrança)",
      areaSoftware: "Software Development & AI",
      areaAIFounder: "AI Product Founder",
    },
    filtersReplikers: {
      areaLabel: "Área / Categoría",
      applyButton: "Aplicar Filtros",
      all: "Todos",
      generalist: "Generalista",
    },
    about: {
      // Títulos principais
      whoWeAre: "Quem Somos",
      forWho: "Para Quem é a Replikers?",
      challengeProposal: "Por Que a Replikers? O Desafio e Nossa Proposta",
      whatIsRepliker:
        "O que é um Repliker? Sua Réplica Digital de Alto Desempenho",
      impact: "O Impacto de um Repliker: Escale Seus Serviços, Não Suas Horas",
      visionMission: "Nossa Visão, Missão e Seu Próximo Passo",

      // Contenido - Quiénes Somos
      whoWeAreP1_1:
        "Na RepliKers, estamos construindo o Sistema Operacional IA First que todo profissional que busca independência precisa para alcançar um crescimento exponencial. Fundada em Agosto de 2024, nossa missão é transformar seu conhecimento em uma réplica digital inteligente capaz de automatizar vendas, marketing e atendimento ao cliente. Ao integrar ferramentas como o Google (Gmail), permitimos que sua réplica gerencie de forma eficiente sua comunicação profissional com respostas rápidas e personalizadas, impulsionando seu impacto como profissional independente sem comprometer a privacidade de seus dados.",

      // Contenido - Para Quem
      forWhoP1:
        "Nosso sistema é projetado para o especialista de alto valor que deseja crescer e escalar seu impacto sem sacrificar sua vida pessoal.",
      proTitle: "O Profissional Independente:",
      proP1:
        "Se você já possui expertise comprovada e deseja multiplicar sua receita e alcance sem comprometer seu tempo pessoal, a Replikers é sua aliada.",
      founderTitle: "O Futuro Fundador de uma Consultoria Boutique:",
      founderP1:
        "Aqueles que buscam transformar seu conhecimento individual em uma empresa de serviços boutique, altamente escalável e automatizada, pronta para dominar na era da Inteligência Artificial.",
      challengeP1:
        "Entendemos o desafio: 'Não posso crescer mais sem sacrificar minha vida pessoal.' As tarefas operacionais (vendas, marketing, administração) consomem o tempo que você deveria dedicar à entrega de valor real aos seus clientes.",

      // Contenido - Desafío y Propuesta
      problemTitle: "O Problema Central: Um Crescimento Linear e Exaustivo",
      problemL1:
        "O crescimento profissional costuma ser linear, lento e doloroso.",
      problemL2:
        "Você está investindo tempo valioso em tarefas operacionais repetitivas (comerciais, marketing e administrativas), o que impede você de escalar seu negócio além das suas horas disponíveis e compromete a consistência do seu serviço.",
      opportunityTitle: "Nossa Oportunidade: De Linear para Exponencial",
      opportunityP1_1:
        "A Replikers transforma sua experiência e seu tempo em um Ativo Digital 24/7 que trabalha incansavelmente por você. Nós movemos você de um modelo de negócio linear para um exponencial, escalando sua metodologia e não apenas suas horas de trabalho.",

      // Contenido - Qué es un Repliker
      whatIsP1:
        "Um Repliker é o seu Sistema Operacional IA First: uma extensão inteligente, capacitada pelo seu conhecimento e treinada especificamente na sua metodologia para impulsionar seu crescimento independente.",
      whatIsP2:
        "Essencialmente, é um assistente de vendas e serviço hiper-especializado que carrega seu nome e sobrenome, treinado unicamente nos seus processos e filosofia.",
      componentsTitle: "Seus Componentes Chave:",
      componentL1Title: "Hiper-Especialização (DNA Único):",
      componentL1Desc:
        "Construído com Fine Tuning e Retrieval-Augmented Generation (RAG) sobre seus dados únicos (playbooks, insights, modelos), seu Repliker adota sua personalidade. Não é um agente de IA genérico; é o único capaz de entregar seu serviço exatamente como você faria.",
      componentL2Title: "Funcionalidade Autônoma:",
      componentL2Desc:
        "Treinado para Observar, Raciocinar e Agir, seu Repliker se conecta às suas ferramentas chave (Google Calendar, e-mail, WhatsApp, RRSS) para executar fluxos de trabalho completos. Isso significa que ele pode realizar tarefas sem supervisão, desde buscar leads até gerenciar sua caixa de entrada unificada.",
      componentL3Title: "Estratégia de Monetização Inteligente:",
      componentL3Desc:
        "Seu Repliker pode oferecer consultorias, executar tarefas ou agendar consultas personalizadas, cobrando automaticamente antes de entregar o serviço. Isso gera receita passiva através de múltiplas fontes: consultorias, tarefas específicas, publicidade e tráfego da comunidade.",

      // Contenido - Impacto
      impactP1_1:
        "Seu Repliker é o motor que orquestra e automatiza o crescimento do seu negócio profissional independente, permitindo que você ",
      impactP1_2: "escale seus serviços, não suas horas.",
      impactP1_3:
        "Somos especializados em potencializar consultores independentes, freelancers e na criação de consultorias boutique.",
      benefitsTitle: "Benefícios Chave:",
      benefitL1Title: "Vendas e Marketing 24/7:",
      benefitL1Desc:
        "Seu Repliker atende e qualifica cada lead das suas redes sociais, WhatsApp ou e-mail. É seu consultor de vendas incansável, criando e gerenciando seu funil de vendas de forma automática.",
      benefitL2Title: "Escalabilidade Garantida:",
      benefitL2Desc:
        "Amplia seu alcance globalmente, disponível 24 horas por dia, 7 dias por semana, em qualquer idioma. Mantém uma qualidade de resultado consistente sem consumir suas horas pessoais.",
      benefitL3Title: "Blindagem contra a IA:",
      benefitL3Desc:
        "Oferece uma vantagem competitiva única. Em vez de competir contra agentes de IA genéricos, você usa seu Repliker para multiplicar sua eficiência, velocidade e capacidade de análise de dados.",
      benefitL4Title: "Imagem Profissional Aprimorada:",
      benefitL4Desc:
        "Projeta uma representação consistente, precisa e de vanguarda da sua expertise, elevando sua marca pessoal como um líder que domina a Inteligência Artificial.",
      benefitL5Title: "Superpoderes:",
      benefitL5Desc:
        "Adquira os superpoderes de um ativo digital: Disponibilidade 24/7, Escalabilidade ilimitada, Velocidade de Execução sem precedentes e Preços Competitivos.",
      benefitL6Title: "Caixa de Entrada Unificada e Inteligente:",
      benefitL6Desc:
        "Receba todas as comunicações dos seus leads unificadas e filtradas pelo seu Repliker. Você verá apenas o importante, e seu Repliker sempre responderá ao essencial e urgente.",
      benefitL7Title: "Busca Ativa de Emprego:",
      benefitL7Desc:
        "Se desejar, seu Repliker pode buscar proativamente oportunidades de emprego tradicionais, otimizando suas possibilidades.",

      // Contenido - Visión y Misión
      visionTitle: "Visão:",
      visionP1:
        "Ser o Sistema Operacional IA FIRST líder global, escalando o conhecimento profissional e transformando-o em Empresas de Serviços Boutique ou Serviços Profissionais Independentes totalmente automatizadas, eliminando a dor da escala através da IA.",
      missionTitle: "Missão:",
      missionP1:
        "Criar um sistema operacional impulsionado por IA FIRST que execute e orquestre todas as tarefas comerciais, marketing e administrativas que um profissional independente precisa para crescer e escalar.",
      competitiveTitle: "Nossa Vantagem Competitiva:",
      competitiveP1:
        "A automação completa de todas as tarefas (comerciais, marketing, administrativas) que um profissional independente precisa para crescer, focada no seu conhecimento e expertise únicos.",
      readyForFutureTitle: "Pronto para o Futuro?",
      readyForFutureP1_1:
        "Se você está pronto para parar de vender suas horas e começar a vender seu ativo digital, agende uma reunião agora para começar a construir seu Repliker:",
      scheduleLink: "https://bit.ly/CitaRepliker",
    },
    chat: {
      replikerNotFound: "Repliker não encontrado.",
      emptyChatPrompt: "Em que posso ajudar você hoje?",
      loginPrompt: "Por favor, faça login para conversar.",

      // Indicadores de estado de la IA
      thinking: "Pensando...",
      thinkingMoment: "Um momento...",
      thinkingRefining: "Refinando...",

      // Manejo de errores y acciones
      errorDefault: "Desculpe, ocorreu um erro.",
      newChat: "Novo Chat",
      noActiveConversation: "Nenhuma conversa ativa para enviar a mensagem.",
      requestCanceled: "Solicitação cancelada pelo usuário.",

      // Drag & Drop
      dropzone: "Solte seu PDF ou JPG aqui para anexar",
      unsupportedFile:
        "Tipo de arquivo não suportado. Por favor, envie arquivos PDF, JPG ou PNG.",

      // Sidebar
      newConversationButton: "Nova Conversa",
    },
    chatComponent: {
      // ProfleSidebar
      share: "Compartilhar",
      historyTitle: "Histórico de Conversas",
      newConversationButton: "+ Nova Conversa",
      updateError: "Erro ao atualizar o nome da conversa.",
      userLabel: "Você",
      botLabel: "Bot",

      // ChatMessage (Archivos)
      fileDefaultName: "Arquivo",
      fileAttachedLabel: "Arquivo anexado:",
      imageAlt: "Anexo",
      viewLink: "Ver link",

      // AudioRecordModal
      modalTitle: "Gravar Áudio",
      closeButtonLabel: "Fechar",
      statusIdle: "Pressione para gravar",
      statusRecording: "Gravando...",
      statusRecorded: "Áudio gravado",
      buttonRecord: "Gravar",
      buttonStop: "Parar",
      buttonRecordAgain: "Gravar novamente",
      buttonCancel: "Cancelar",
      buttonSend: "Enviar",
      errorMicrophoneAccess:
        "Não foi possível acessar o microfone. Verifique as permissões.",
      errorRecordingStop: "Ocorreu um erro ao parar a gravação.",

      // ConversationBar (Input/Placeholder/Botones)
      filePreviewAlt: "Pré-visualização do arquivo",
      attachFileTitle: "Anexar arquivo",
      attachFileLabel: "Anexar arquivo",
      recordAudioTitle: "Gravar áudio",
      recordAudioLabel: "Gravar áudio",
      placeholderThinking: "Aguardando resposta...",
      placeholderDefault: "Pergunte o que quiser",
      stopButtonAlt: "Parar",
    },
    blog: {
      // Títulos y mensajes de estado
      heroTitle: "Confira nosso blog",
      loading: "Carregando blogs...",

      // Botones y acciones
      readArticle: "Ler artigo",

      // Mensajes de error/verificación (Modales)
      verificationError: "Código de verificação incorreto.",
      verificationErrorGeneral: "Erro ao verificar o código.",

      // Accesibilidad
      heroAlt: "Fundo de herói do blog",
    },
    editBlog: {
      modalTitle: "Editar Blog",
      titleLabel: "Título:",
      dateLabel: "Data:",
      imageUrlLabel: "URL da Imagem:",
      contentLabel: "Conteúdo (Markdown):",
      updateButton: "Atualizar Blog",

      // Mensajes de estado
      updating: "Atualizando blog...",
      success: "Blog atualizado com sucesso!",
      errorDefault: "Não foi possível atualizar o blog.",
      errorPrefix: "Erro:",
    },
    blogPost: {
      loading: "Carregando artigo...",

      // Mensajes de error
      notFoundTitle: "Artigo não encontrado",

      // Enlaces
      backToBlog: "Voltar ao blog",
      backToBlogList: "Voltar para a lista de blogs",

      // Etiquetas
      publicationDate: "Data de publicação:",
      relatedBlogsTitle: "Artigos relacionados",
    },
    notifications: {
      like: "{name} curtiu sua publicação",
      follow: "{name} começou a seguir você",
      comment: "{name} comentou na sua publicação",
      reply: "{name} respondeu ao seu comentário",
      mention: "{name} mencionou você em uma publicação",
      default: "{name} interagiu com você",
    },
    social: {
      // General & Sidebar
      headerTitle: "Social",
      navHome: "Início",
      navExplore: "Explorar",
      navNotifications: "Notificações",
      navFollowing: "Seguindo",
      navMessages: "Mensagens",
      navProfile: "Perfil",
      navPostBtn: "Publicar",
      whatsHappening: "O que está acontecendo",

      // ChatPage
      loading: "Carregando...",
      loadingChat: "Carregando chat...",
      noConversationsTitle: "Ainda não tem mensagens",
      noConversationsText: "Envie uma mensagem para iniciar uma conversa.",
      clearChat: "Limpar chat",
      deleteConversation: "Excluir conversa",
      selectMessageTitle: "Selecione uma mensagem",
      selectMessageText:
        "Escolha entre suas conversas existentes, inicie uma nova ou continue nadando.",
      newMessageBtn: "Nova mensagem",
      newMessageModalTitle: "Nova mensagem",
      nextBtn: "Próximo",
      noPeopleFound: "Nenhuma pessoa encontrada",

      // ExplorePage
      exploreTitle: "Explorar",
      newContentTitle: "Novo conteúdo em breve!",
      newContentText:
        "Estamos trabalhando em novas formas de descobrir conteúdo.",

      // PostFeed & PostDetail
      postHeader: "Publicação",
      loadMore: "Carregar mais",
      feedEnd: "Não há mais publicações",
      feedEmpty: "Ainda não há publicações",

      // CreatePost
      loginToShare: "Faça login para compartilhar seus pensamentos...",
      createPostPlaceholder: "O que está acontecendo?!",
      postingBtn: "Publicando...",
      postBtn: "Publicar",

      // CommentSection
      loadingComments: "Carregando comentários...",
      editBtn: "Editar",
      deleteBtn: "Excluir",
      saveBtn: "Salvar",
      cancelBtn: "Cancelar",
      addCommentPlaceholder: "Adicione um comentário...",
      replyingTo: "Respondendo a",

      // NotificationsPage
      notificationsTitle: "Notificações",
      loginNotifTitle: "Faça login para ver notificações",
      loginNotifText:
        "Junte-se à conversa para ver quem está interagindo com você.",
      loginBtn: "Entrar",
      noNotificationsTitle: "Nenhuma notificação ainda",
      noNotificationsText:
        "Quando alguém curtir sua publicação ou seguir você, você verá aqui.",

      // PostItem (Novas adições planas)
      postShareMsgPrefix: "Quero falar mais sobre:",
      postShareMsgImg: "esta imagem/vídeo",
      postShareMsgPost: "esta publicação",
      postSharedFrom: "Publicação compartilhada de",
      postFollow: "Seguir",
      postFollowing: "Seguindo",
      postEdit: "Editar",
      postDelete: "Excluir",
      postDeleteConfirm: "Tem certeza de que deseja excluir esta publicação?",
      postShareVia: "Compartilhar via",
      postCopyLink: "Copiar link",
      postSendTo: "Falar com o repliker",
      postLinkCopied: "Link copiado para a área de transferência!",
      postEditError: "Falha ao editar publicação",
      postDeleteError: "Erro ao excluir publicação",
      postReadMore: "Ler mais",
      postShowLess: "Mostrar menos",
      postSave: "Salvar",
      postCancel: "Cancelar",
      postCommentedLabel: "Comentou",
      postTooltipMore: "Mais opções",
      postTooltipReply: "Responder",
      postTooltipShare: "Compartilhar",
      postTooltipLike: "Curtir",
      postTooltipViews: "Visualizações",
      postTooltipSendRepliker: "Falar com o repliker",

      // Repli Post + Blog
      repliGenerateBlog: "Você também quer que eu gere um blog SEO para seu site?",
      repliGenerateBlogYes: "Sim, gerar blog!",
      repliGenerateBlogNo: "Apenas post",
      repliPublishing: "Publicando...",
      repliPostPublished: "Post publicado!",
      repliBlogPublished: "Blog publicado!",
      repliBothPublished: "Post e blog publicados!",
      repliPublishError: "Erro ao publicar",
      repliEditPost: "Editar post",
      repliEditBlog: "Editar blog",
      repliPublish: "Publicar",
      repliBlogTitle: "Título do blog",
      repliBlogContent: "Conteúdo do blog",
      repliBlogImageUrl: "URL da imagem",

      // SocialProfilePage
      profileCheckOut: "Confira o perfil de {name} no Replikers!",
      profileLinkCopied: "Link do perfil copiado para a área de transferência!",
      profileUserNotFound: "Usuário não encontrado",
      profilePostsCount: "publicações",
      profileAddCover: "Adicionar foto de capa",
      profileEditBtn: "Editar Perfil",
      profileShareTooltip: "Compartilhar Perfil",
      profileBioPlaceholder: "Adicionar descrição",
      profileStatsFollowing: "Seguindo",
      profileStatsFollowers: "Seguidores",
      profileTabPosts: "Publicações",
      profileTabReplies: "Respostas",
      profileRepliedTo: "Respondeu a",
      profileNoPosts: "Ainda não há publicações",
      profileNoReplies: "Ainda não há respostas",
      profileComingSoon: "Em breve",

      // Edit Profile Modal
      profileModalTitle: "Editar Perfil",
      profileLabelName: "Nome",
      profileLabelUsername: "Nome de usuário",
      profileLabelBio: "Biografia",
      profileInputBioPlaceholder: "Adicione uma biografia ao seu perfil",
      profileSaving: "Salvando...",
      profileSave: "Salvar",
      profileUpdateError: "Erro ao atualizar perfil",

      // UserSearch
      searchPlaceholder: "Pesquisar",
      searchNoResults: "Nenhum resultado encontrado",
      searchOwnersTitle: "Nossos Replikers",
      searchOwnersSubtitle: "Descubra as novidades dos nossos replikers",
    },
    profile: {
      // Tabs
      myAccount: "Minha Conta",
      myPurchases: "Minhas Compras",
      myRepliker: "MEU REPLIKER",
      myMessaging: "Minha mensageria",
      addContent: "ADICIONA CONTEÚDO",
      settings: "Configurações",
      uploadedFiles: "Arquivos enviados",
      returnToChat: "Voltar para o chat",
      // Mi Cuenta
      myProfileTitle: "Meu Perfil",
      changePhoto: "Trocar foto",
      loading: "Carregando...",
      logout: "Sair",
      personalInfo: "Informações pessoais",
      edit: "Editar",
      country: "País",
      selectCountry: "Selecione um país",
      phone: "Número de telefone",
      update: "Atualizar",
      cancel: "Cancelar",
      notAvailable: "Não disponível",
      saved: "Perfil atualizado!",
      errorSave: "Erro ao atualizar!",
      name: "Nome",
      displayNameLabel: "Nome de exibição:",
      displayNamePlaceholder: "Seu nome Completo",
      professionLabel: "FUNÇÃO / CARGO / PROFISSÃO:",
      professionPlaceholder: "Ex: Eng. de Software (Obrigatório para seu Repliker)",
      areaLabel: "Área / Categoria:",
      selectCategory: "Selecione uma categoria (Obrigatório para seu Repliker)",
      // Subtabs
      aiAnalysis: "Análise IA",
      summary: "Resumo",
      // Analysis Section
      analysisBadge: "Análise de Insights",
      analysisDesc: "Pergunte ao seu Repliker sobre o desempenho de suas postagens, interações e comportamento do público.",
      resetAnalysis: "Reiniciar Análise",
      analysisReady: "Seu assistente de dados está pronto. O que você gostaria de analisar hoje?",
      analysisPlaceholder: "Ex: Que tipo de conteúdo gerou mais comentários este mês?",
      clearChat: "Limpar Conversação",
      activeAgent: "Agente Ativo",
      days7: "7 Dias",
      days30: "30 Dias",
      months3: "3 Meses",
      viewsTrend: "Tendência de Vistas",
      interactionPeaks: "Picos de Interação",
      conversionFunnel: "Funil de Conversão",
      noText: "Sem texto",
      searchById: "Buscar por ID...",
      sessionId: "ID Sessão",
      fullTranscript: "Transcrição Completa",
      downloadTxt: "Baixar TXT",
      noMessagesInConv: "Nenhuma mensagem nesta conversa.",
      highRelation: "Relação Alta",
      file: "Arquivo",
      view: "Ver",
      noFilesUploaded: "Nenhum arquivo enviado ainda.",
      addPostPlaceholder: "Descreva o conteúdo que deseja criar ou anexe um arquivo...",
      // Mis Compras
      historyPurchases: "Histórico de Compras",
      historyPurchasesDesc:
        "Se você fez compras ou adquiriu serviços e eles não aparecem aqui, não se preocupe, estamos trabalhando nisso.",
      // Dashboard
      dashboardTitle: "Dashboard do Meu Repliker",
      chatHistory: "Histórico de Conversas",
      recentConvs: "Conversas Recentes:",
      loadingHistory: "Carregando histórico de conversas...",
      noHistory: "Nenhuma conversa recente do seu Repliker.",
      session: "Sessão",
      with: "com",
      userLabel: "Usuário",
      replikerLabel: "Repliker",
      noMessages: "Nenhuma mensagem nesta sessão.",
      seeFullHistory: "Ver Histórico Completo",
      // Mi mensajeria
      menssagingTitle: "Minha mensageria",
      menssagingSubtitle: "Centralize suas notificações do Gmail e LinkedIn em um só lugar.",
      providerGmail: "Google Gmail",
      providerLinkedIn: "LinkedIn",
      connectGmail: "Conectar Gmail",
      connectLinkedIn: "Conectar LinkedIn",
      unifiedInbox: "Caixa de Entrada Unificada",
      loadingNotifs: "Carregando notificações...",
      noNotifs: "Você não tem notificações pendentes.",
      notifFromLabel: "De:",
      notifCloseBtn: "Fechar",
      notifDisclaimer: "Nota: Esta é uma visualização da mensagem unificada.",
      errorLoadNotifs: "Erro ao carregar notificações. Certifique-se de conectar suas contas.",
      errorConnectGoogle: "Erro ao iniciar a conexão com o Google.",
      errorConnectLinkedIn: "Erro ao iniciar a conexão com o LinkedIn.",
      // Añade contenido
      addPostTitle: "Adicione conteúdo com Repli",
      addPostText:
        "Descreva o conteúdo que você quer enviar ou anexe um arquivo para que o Repli o processe.",
      addPostEmptyChatMsg: "Que conteúdo você gostaria de adicionar hoje?",
      creativeStudio: "Estúdio Criativo",
      templateSocial: "Post para Redes",
      templateBlog: "Artigo de Blog",
      templateVideo: "Roteiro de Vídeo",
      templateNewsletter: "Newsletter",
      // Settings
      theme: "Tema",
      dark: "Escuro",
      light: "Claro",
      language: "Idioma",
      spanish: "Espanhol",
      english: "Inglês",
      portuguese: "Português",
      // Tooltips for Insights
      infoViewsTrend: "Mostra a evolução do número de visualizações dos seus conteúdos ao longo do período selecionado.",
      infoInteractionPeaks: "Identifica os momentos com o maior número de interações (curtidas, comentários, compartilhamentos) em suas postagens.",
      infoConversionFunnel: "Visualiza a jornada do usuário desde a visualização do seu conteúdo até o início de uma conversa com o seu Repliker.",
      infoTotalViews: "Número total de vezes que suas postagens foram visualizadas pelos usuários.",
      infoTotalPosts: "Quantidade total de conteúdos que você publicou na plataforma.",
      infoTotalInteractions: "Soma total de curtidas, comentários e compartilhamentos do seu conteúdo.",
      infoConvsStarted: "Número de vezes que um usuário iniciou um chat diretamente com seu Repliker a partir de seus conteúdos.",
      infoAvgDwellTime: "Tempo médio que os usuários passam visualizando suas postagens.",
      comingSoon: "Em breve novos idiomas/temas.",
      // Insights
      insightsTitle: "Insights de Desempenho",
      insightsSummary: "Resumo de Desempenho",
      totalPosts: "Total de Publicações",
      totalViews: "Visualizações Totais",
      totalInteractions: "Interações Totais",
      convsStarted: "Conversas Iniciadas",
      postDetails: "Detalhes por Publicação",
      interactions: "Interações",
      views: "Visualizações",
      comments: "Comentários",
      shares: "Compartilhamentos",
      avgDwellTime: "Tempo Médio",
      dwellTime: "Permanência",
      ctrActions: "CTR / Ações",
      showMore: "Ver mais",
      showLess: "Ver menos",
      // CRM
      crmTab: "CRM",
      crmTitle: "Gestão de Contatos (Leads)",
      crmDesc: "Aqui aparecem os dados capturados pelo seu Repliker quando um usuário fornece suas informações.",
      colName: "Nome",
      colEmail: "Email",
      colPhone: "Telefone",
      colRole: "Papel",
      colCompany: "Empresa",
      colService: "Serviço de Interesse",
      colDetails: "Detalhes do Problema",
      // Novas colunas CRM
      colContactType: "Tipo de Contato",
      colWebsite: "Site / Website",
      colAddress: "Endereço",
      colCity: "Cidade",
      colCountry: "País",
      colLinkedin: "LinkedIn",
      colEmailPref: "Pref. de E-mail",
      colOrigin: "Origem",
      colLastContact: "Último Contato",
      colDate: "Data da Captura",
      noLeads: "Ainda não há leads capturados.",
      loadingLeads: "Carregando contatos...",
      becomeOwnerSuccessMsgShort: "Conta Owner ativada",
      becomeOwnerRevoked: "Conta Owner revogada. Contate o suporte: +1 (415) 604-6499 | hola@replikers.com",
      createOrEditRepliker: "Crie ou Edite seu Repliker",
      missingFieldsError: "Faltam campos para completar.",

      // Guest Restricted
      guestRestrictedTitle: "Acesso Limitado",
      guestRestrictedDesc: "Como convidado, você não pode personalizar seu perfil ou acessar recursos avançados. Registre-se para desbloquear todas as ferramentas.",
    },
    verificationModal: {
      modalTitle: "Verificação Necessária",
      descriptionP1:
        "Para editar este artigo, por favor, insira o código de verificação:",
      placeholder: "Código de verificação",
      buttonVerify: "Verificar",
    },
    repli: {
      placeholder: "Digite sua mensagem...",
      buttonSend: "Enviar",
      errorDefault: "Desculpe, não foi possível processar sua solicitação.",
      errorContact: "Erro ao contatar o agente Repli:",
    },
    login: {
      welcomeTitle: "Bem-vindo à comunidade Replikers",
      loginHeader: "Entre com",
      loginButtonGoogle: "Entrar com Google",
      loginButtonEmail: "Entrar com Email",
      guestButton: "Continuar como Convidado",
      braveWarningBold: "Usando o Brave?",
      braveWarningText:
        "Se o login com o Google falhar, desative temporariamente os Escudos (ícone do leão) para este site.",
      privacyMessage:
        "Usamos sua conta Google apenas para autenticá-lo. Não acessamos informações privadas.",
      poweredBy: "Desenvolvido por Conauti",
      guestError: "Não foi possível entrar como convidado. Tente novamente.",
      googleLogoAlt: "Logo do Google",
      emailLogoAlt: "Logo do Email",
      userLogoAlt: "Logo do Usuário",
      registerSuccess: "Registro bem-sucedido",

      // LoginForm
      loginTitle: "Entre no",
      emailPlaceholder: "Endereço de Email",
      passwordPlaceholder: "Senha",
      loginButton: "Entrar",
      loadingButton: "Entrando...",
      errorSession:
        "Não foi possível fazer login no servidor. Tente novamente.",
      errorVerificationNeeded:
        "Seu e-mail não foi verificado. Por favor, verifique sua caixa de entrada.",
      errorLoginFailed: "Ocorreu um erro ao fazer login.",
      errorInvalidCredentials: "O e-mail ou a senha estão incorretos.",
      errorInvalidEmailFormat: "O formato do e-mail é inválido.",
      resendButton: "Reenviar e-mail de verificação",
      resendSuccess:
        "O e-mail de verificação foi reenviado. Por favor, verifique sua caixa de entrada.",
      resendError:
        "Não foi possível reenviar o e-mail de verificação. Tente novamente mais tarde.",
      toggleRegister: "Não tem uma conta? Cadastre-se",

      // RegisterForm
      registerTitle: "Cadastre-se no",
      confirmPasswordPlaceholder: "Confirmar Senha",
      registerButton: "Cadastrar",
      errorPasswordMismatch: "As senhas não coincidem.",
      errorPasswordLength: "A senha deve ter pelo menos 6 caracteres.",
      errorRegisterFailed: "Ocorreu um erro durante o cadastro.",
      errorEmailInUse: "O endereço de e-mail já está em uso.",
      errorInvalidEmail: "O endereço de e-mail é inválido.",
      errorWeakPassword: "A senha é muito fraca.",
      registerSuccessAlert:
        "Cadastro bem-sucedido! Um e-mail de verificação foi enviado para o seu endereço. Por favor, verifique seu e-mail antes de fazer login.",
      toggleLogin: "Já tem uma conta? Entrar",
    },
    privacyPolicy: {
      backBtn: "← Voltar ao início",
      mainTitle: "Política de Privacidade",
      lastUpdate: "Última atualização: 05 de janeiro de 2026",

      // Seção 1
      sec1Title: "1. Introdução",
      sec1Text:
        "Na RepliKers, a privacidade de nossos usuários é nossa prioridade. Esta política detalha como coletamos, usamos e protegemos suas informações quando você utiliza nossa plataforma e, especificamente, nossa integração com os serviços do Google.",

      // Seção 2
      sec2Title: "2. Dados do Google que Coletamos",
      sec2Sub1: "2.1. Autenticação Google OAuth2",
      sec2Text1: "Quando você faz login com o Google, acessamos:",
      sec2List1Item1:
        "Email: Seu endereço de e-mail para identificar sua conta",
      sec2List1Item2:
        "Nome: Seu nome completo para personalizar sua experiência",
      sec2List1Item3:
        "Foto de perfil: URL da sua foto para exibir no seu perfil",
      sec2List1Item4:
        "ID do Google: Identificador único para vincular sua conta",

      sec2Sub2: "2.2. Integração Gmail API",
      sec2Text2: "Quando você conecta sua conta do Gmail, acessamos:",
      sec2List2Item1:
        "E-mails não lidos: Metadados (assunto, remetente, data) dos últimos 10 e-mails não lidos",
      sec2List2Item2:
        "Fragmento de conteúdo: Um breve resumo (snippet) de cada e-mail para visualização",
      sec2List2Item3:
        "Identificadores: ID único de cada mensagem para rastreamento",
      sec2List2Item4:
        "Tokens de acesso: access_token e refresh_token para manter a conexão ativa",
      sec2Important:
        "Importante: NÃO acessamos o conteúdo completo de seus e-mails, apenas metadados para notificações.",

      // Seção 3
      sec3Title: "3. Como Usamos os Dados do Google",
      sec3Sub1: "3.1. Dados de Autenticação",
      sec3Text1: "Usamos seus dados de autenticação para:",
      sec3List1Item1: "Criar e gerenciar sua conta de usuário na RepliKers",
      sec3List1Item2: "Fazer login de forma segura sem necessidade de senha",
      sec3List1Item3:
        "Personalizar sua experiência com seu nome e foto de perfil",
      sec3List1Item4: "Identificá-lo de forma única em nosso sistema",

      sec3Sub2: "3.2. Dados do Gmail",
      sec3Text2: "Usamos os dados do Gmail exclusivamente para:",
      sec3List2Item1:
        "Mostrar notificações: Visualizar e-mails não lidos no seu painel de mensagens",
      sec3List2Item2:
        "Unificar comunicações: Centralizar seus alertas profissionais em um só lugar",
      sec3List2Item3:
        "Atualização em tempo real: Refletir o status atual da sua caixa de entrada",

      sec3ComplianceTitle:
        "Conformidade com a Política de Uso Limitado do Google:",
      sec3ComplianceItem1: "NÃO usamos seus dados do Gmail para publicidade",
      sec3ComplianceItem2:
        "NÃO vendemos, alugamos ou compartilhamos seus dados com anunciantes",
      sec3ComplianceItem3:
        "NÃO usamos seus dados para treinar modelos de IA externos",
      sec3ComplianceItem4:
        "NÃO armazenamos o conteúdo completo de seus e-mails",
      sec3GooglePolicyLink:
        "Política de Dados do Usuário dos Serviços de API do Google",
      sec3GooglePolicyText:
        "O uso das informações recebidas das APIs do Google aderirá estritamente à Política de Dados do Usuário dos Serviços de API do Google, incluindo os requisitos de Uso Limitado.",

      // Seção 4
      sec4Title: "4. Com Quem Compartilhamos os Dados do Google",
      sec4Sub1:
        "4.1. NÃO Compartilhamos seus Dados com Terceiros para Publicidade",
      sec4Text1:
        "A RepliKers NÃO vende, aluga ou transfere seus dados do Google para terceiros para fins de marketing ou publicidade.",

      sec4Sub2: "4.2. Provedores de Serviços Essenciais",
      sec4Text2:
        "Podemos compartilhar seus dados apenas com os seguintes provedores de serviços essenciais que nos ajudam a operar nossa plataforma:",
      sec4List1Item1:
        "Google Cloud Platform: Para armazenamento seguro de tokens de acesso (servidor)",
      sec4List1Item2:
        "Google OAuth2: Para autenticação segura (apenas troca de tokens)",
      sec4Note1:
        "Esses provedores são proibidos de usar seus dados para qualquer finalidade diferente de fornecer serviços à RepliKers.",

      sec4Sub3: "4.3. Pessoal Autorizado",
      sec4Text3:
        "Apenas pessoal autorizado da RepliKers pode acessar seus dados para:",
      sec4List2Item1:
        "Fornecer suporte técnico quando você solicitar explicitamente",
      sec4List2Item2: "Realizar manutenção e depuração do sistema",
      sec4List2Item3:
        "Investigar atividades suspeitas ou incidentos de segurança",
      sec4Note2:
        "Todo o acesso por parte do pessoal é monitorado e sujeito a rigorosos acordos de confidencialidade.",

      sec4Sub4: "4.4. Requisitos Legais",
      sec4Text4:
        "Poderemos compartilhar ou transferir seus dados se exigido por lei, incluindo:",
      sec4List3Item1: "Conformidade com ordens judiciais ou requisitos legais",
      sec4List3Item2: "Proteção de nossos direitos, propriedade ou segurança",
      sec4List3Item3: "Prevenir fraudes ou atividades ilícitas",

      sec4Sub5: "4.5. Controle do Usuário",
      sec4Text5: "Você tem controle total sobre seus dados:",
      sec4List4Item1:
        "Pode revogar o acesso a qualquer momento através da sua conta Google",
      sec4List4Item2:
        "Pode remover a integração através do seu perfil na RepliKers",
      sec4List4Item3:
        "Ao revogar, todos os tokens de acesso são excluídos imediatamente",

      sec4Sub6: "4.6. Dados que Compartilhamos com o Google",
      sec4Text6:
        "Compartilhamos com o Google APENAS o necessário para o funcionamento da integração:",
      sec4List5Item1:
        "Tokens de autenticação: Trocamos o código OAuth2 por tokens de acesso",
      sec4List5Item2:
        "Solicitações de API: Enviamos seus tokens para autenticar solicitações à Gmail API",
      sec4Note3:
        "NÃO compartilhamos nenhum dado adicional com o Google além do necessário para a operação OAuth2 e chamadas de API autorizadas.",

      // Seção 5
      sec5Title: "5. Armazenamento e Retenção de Dados",
      sec5Sub1: "5.1. Armazenamento",
      sec5Text1: "Armazenamos os seguintes dados:",
      sec5List1Item1:
        "Tokens de acesso: Mantemos access_token e refresh_token em nosso banco de dados para manter su conexão ativa",
      sec5List1Item2:
        "Metadatos do Gmail: NÃO armazenamos os metadados de e-mails em nosso banco de dados; eles são exibidos apenas temporariamente na sua sessão",
      sec5List1Item3:
        "Perfil de usuário: Armazenamos seu nome, e-mail e foto em sua conta de usuário",

      sec5Sub2: "5.2. Retenção e Exclusão",
      sec5List2Item1:
        "Tokens: Excluídos imediatamente quando você revoga o acesso ou exclui sua conta",
      sec5List2Item2:
        "Metadatos de e-mails: Não persistem; são apagados ao sair",
      sec5List2Item3:
        "Perfil: Mantidos até que você exclua sua conta ou solicite sua exclusão",

      // Seção 6
      sec6Title: "6. Segurança dos Dados",
      sec6Text: "Implementamos múltiplas camadas de segurança:",
      sec6ListItem1:
        "Criptografia em trânsito: Todas as comunicações usam HTTPS/TLS 1.3",
      sec6ListItem2:
        "Criptografia em repouso: Tokens de acesso criptografados no banco de dados",
      sec6ListItem3:
        "Rotação de tokens: Refresh tokens atualizados automaticamente",
      sec6ListItem4:
        "Validação de sessões: Sessões gerenciadas com cookies seguros HttpOnly",
      sec6ListItem5:
        "Controle de acesso: Acesso mínimo necessário (principle of least privilege)",
      sec6ListItem6: "Auditoria: Logs de acesso monitorados regularmente",

      // Seção 7
      sec7Title: "7. Seus Direitos",
      sec7Text: "Sob GDPR e CCPA, você tem direito a:",
      sec7List1Item1: "Acesso: Solicitar cópia de seus dados pessoais",
      sec7List1Item2: "Retificação: Corrigir dados imprecisos ou incompletos",
      sec7List1Item3:
        "Exclusão: Solicitar a exclusão de seus dados ('direito ao esquecimento')",
      sec7List1Item4:
        "Portabilidade: Receber seus dados em formato estruturado",
      sec7List1Item5: "Oposição: Opor-se ao processamento de seus dados",
      sec7List1Item6:
        "Retirar consentimento: Revogar permissões a qualquer momento",

      sec7Text2: "Como exercer seus direitos:",
      sec7List2Item1: "Enviar solicitação para: ",
      sec7List2Item2: "Revogar acesso em: ",
      sec7List2Item3:
        "Remover integração em: Seu Perfil na RepliKers > Mensagens",

      // Seção 8
      sec8Title: "8. Contato",
      sec8Text:
        "Se tiver dúvidas sobre esta política, entre em contato conosco em: ",
    },
    termsOfService: {
      backBtn: "← Voltar ao início",
      mainTitle: "Termos de Serviço",
      lastUpdate: "Última atualização: 05 de janeiro de 2026",

      sec1Title: "1. Aceitação dos Termos",
      sec1Text:
        "Ao acessar e usar a RepliKers, você concorda em ficar vinculado a estes Termos de Serviço e a todas as leis e regulamentos aplicáveis.",

      sec2Title: "2. Uso da Plataforma",
      sec2Text:
        "A RepliKers oferece ferramentas de automação e gerenciamento de mensagens. Você concorda em usar o serviço apenas para fins legais e de acordo com estes termos.",

      sec3Title: "3. Contas e Integrações",
      sec3Text:
        "Para usar certos recursos, como a leitura de notificações do Gmail, você deve conectar suas contas de terceiros. Você é responsável por manter a confidencialidade de suas credenciais e por todas as atividades que ocorram sob sua conta.",

      sec4Title: "4. Propriedade Intelectual",
      sec4Text:
        "Todo o conteúdo, recursos e funcionalidades da RepliKers são propriedade exclusiva da RepliKers e seus licenciadores.",

      sec5Title: "5. Limitação de Responsabilidade",
      sec5Text:
        "Em nenhum caso a RepliKers será responsável por quaisquer danos indiretos, incidentais, especiais, consequenciais ou punitivos resultantes do seu acesso ou uso do serviço.",

      sec6Title: "6. Modificações",
      sec6Text:
        "Reservamo-nos o direito de modificar estes termos a qualquer momento. O uso contínuo do serviço após tais alterações constitui sua aceitação dos novos termos.",
    },
    explore: {
      // Títulos de seções
      trendingTitle: "Tendências",
      suggestedUsersTitle: "Pessoas para seguir",
      replikersTitle: "Descubra Replikers",

      // Tabs
      tabTrending: "Tendências",
      tabUsers: "Usuários",
      tabReplikers: "Replikers",

      // Busca
      searchPlaceholder: "Buscar usuários, posts ou hashtags...",
      searching: "Buscando...",
      searchResults: "Resultados da busca",
      noResults: "Nenhum resultado encontrado",

      // Estados
      loading: "Carregando conteúdo...",
      noBio: "Sem biografia",

      // Ações
      chatNow: "Conversar agora",
      viewProfile: "Ver perfil",
      followers: "seguidores",

      // Sidebar
      trendingHashtags: "Hashtags populares",
      popularReplikers: "Replikers populares",

      // Resultados de busca
      resultsFound: "resultados encontrados",
      relatedPosts: "Posts relacionados",
      postsWithHashtag: "Posts com esta hashtag",
      usersFound: "Usuários encontrados",
      noPostsWithHashtag: "Não há posts com esta hashtag",
      tryDifferentSearch: "Tente termos de busca diferentes",
    },
  },
};
